import   React,
       { useEffect,
         useState,
         useContext } from 'react';
import { withRouter,
         Redirect } from 'react-router-dom';
import { Button,
         Link,
         Fade,
         Container } from '@material-ui/core';
import { makeStyles,
         withStyles } from '@material-ui/core/styles';
import { GATag, 
         sleep,
         Stack } from "../util/tools";
import { processPerRepStars } from '../util/performance';
import { INFO,
         TIMES,
         RUNS,
         clearRUNS,
         CONSTS } from "../util/object";
import { displayBox,
         displayText } from "../util/annotate";
import { getPersonalTarget,
         decodeVideoHash,
         calcPixelDistance,
         parseJSON,
         makeFootageVideoLink,
         parseSliceParams,
         findSkipSteps,
         downloadEmbededVideos,     // vimeo download
         NOW,
         } from "../util/util";
import { appContext } from "./index";
import { VIMEO_POST } from "../util/constants";
import   Tutorial  from "./Tutorial";
import { UTIL_useStyles,
         Notice,
         Direction,
        } from "./Util";  
import { FaEdit, 
         } from '../assets/Icons';     //icons: https://fontawesome.com/icons
import { ReadDetect, 
         ReadFootageDetect,
         CreateDetect, 
         RemoveTargetDetect, 
         InsertTargetDetect } from '../util/database';
import { VideoFrame, VideoControl } from "./VideoPlayer";
import { AuthClass } from '../class/AuthClass';
import { AnnotationClass } from '../class/AnnotationClass';        // canvas abstraction
//import { parseSliceParams } from '@tensorflow/tfjs-core/dist/ops/slice_util';
//import { VideoPlayerClass } from '../class/VideoPlayerClass';        // abstraction
//var Auth = new AuthClass();
//var xPlayer = new VideoPlayerClass();

const mock_useStyles = makeStyles(theme => ({
    old_mock0_root: {
        display: 'block',
        position: 'relative',       // need this for child absolute
        flexDirection: 'column',
        justifySelf: "flex-start",
        top: '0',       //'50px',
        left: '0',
        //width: 'calc(100vw - '+INFO.sidebar_width+')',     //'100%',
        height: '100%',     // was auto
        width: 'auto',     //'100%',
        maxHeight: '100%',
        maxWidth: '100%',
        padding: "0",
        margin: '0',
        //paddingTop: '50px',
        //backgroundColor: 'rgba(200,0,0,0.2)',     // transparent
    },
    mock_root: {
        display: 'flex',
        position: 'relative',
        flexDirection: 'row',       //'column',
        justifySelf: "flex-start",
        //top: '0',       //'50px',
        //left: '0',

        padding: '0',
        margin: '0',
        paddingTop: CONSTS.GOBACK_BAR_HEIGHT+"px",
        height: 'auto',     // was auto
        width: 'auto',      //'100%',
        zIndex: '0',
        //backgroundColor: '#ffffff',     //'rgba(200,0,0,0.2)',     // transparent
    },
    mock_input_layer: {
        display: 'block',
        position: 'absolute',
        top: '0',
        left: '0',
        //height: '100%',     // THIS WILL STRECH Y, MESS UP CLICK-Y!! 
        width: '100%',
        padding: "0",
        cursor: "pointer", 
        zIndex: '180',
        //backgroundColor: 'rgba(200,0,0,0.2)',     // transparent
    },
    mock_buffer_layer: {
        display: 'block',
        position: 'absolute',
        top: '0',
        left: '0',
        width: '100%',
        padding: "0",
        cursor: "pointer", 
        zIndex: '170',
        //backgroundColor: '#ff000030',     // transparent
    },
    mock_canvas: {
        height: '100%',
        width: '100%',
        maxWidth: '100%',
        margin: '0',
        padding: '0',
        //textAlign: 'center',
        //backgroundColor: 'rgba(255,255,255,0)',     // transparent
        //backgroundColor: 'rgba(0,200,0,0.2)',     // transparent
        //zIndex: '380',        // in front of the targets
    },
    stars_container: {
        display: 'flex',
        flexDirection: 'row',
        position: "absolute", 
        top: "0",       //"50px", 
        right: "10px", 
        width: "120px", 
        height: "40px",
        zIndex: '130',
        //background: "red",
    },
    star_icon: {
        width: '30px',
        height: '30px',
        padding: '0',
        margin: '0',
    },
    edit_icon: {
        width: '30px',
        height: '30px',
        padding: '0',
        margin: '0',
        position: "absolute", 
        top: "0",       //"50px", 
        right: "40px", 
        zIndex: '300',
    },
    easter_container: {
        position: 'absolute',
        right: '0',
        bottom: '50px',
        width: '60px',
        height: '60px',
        zIndex: '1000',
        //backgroundColor: 'red',
    },
}));


// Show simulated game footage and elicit player reaction
//    - improve quick cognitive reaction
//    - support multiple modes, anticipate next player for pass or block
//
const Mock = (props) => {
    const classes = mock_useStyles();
    const Classes = UTIL_useStyles();
    const { State, Dispatch } = useContext(appContext);
    function setState(name, value) {
        //console.log("setState:  ",name," =", value, " @", Stack(new Error().stack));
        Dispatch({ type: [name], value: value });   // reducer wrapper
    }
    const [ Target, setTarget ] = useState(null);
    const [ TargetSize, setTargetSize ] = useState(null);
    const [ TargetRedirect, setTargetRedirect ] = useState("");
    const [ Show, setShow ] = useState(null);
    const [ ShowTutorial, setShowTutorial ] = useState(false);
    const [ ShowVideo, setShowVideo ] = useState(false); 
    const [ Refresh, setRefresh ] = useState(0);
    const [ ShowWarning, setShowWarning ] = useState(false);
    const [ ShowSteps, setShowSteps ] = useState(true);
    const [ ShowTimer, setShowTimer ] = useState(false); 
    const [ ShowEdit, setShowEdit ] = useState(false); 
    const [ ShowPreFlight, setShowPreFlight ] = useState(false);
    const [ ShowDirection, setShowDirection ] = useState(true);
    const [ EditMode, setEditMode ] = useState(false);      // edit in progress

    const [ WarningText, setWarningText ] = useState([]);
    const [ Instrns, setInstrns ] = useState([]);
    const [ Replay, setReplay ] = useState(false);
    const [ StarCnt, setStarCnt ] = useState(0);
    //const [ VimeoType, setVimeoType ] = useState(true);     // if video is vimeo or youtube
    const [ PlayerType, setPlayerType ] = useState(null);     //  [ vimeo, youtube, native ]

    const [ VideoPlayer, setVideoPlayer ] = useState(null);     // abstract player
    const [ VideoWidth, setVideoWidth ] = useState(null);
    const [ VideoHeight, setVideoHeight ] = useState(null);
    const [ Footage, setFootage ] = useState(null);
    const [ Footages, setFootages ] = useState([]); 
    //const [ VideoHash, setVideoHash ] = useState(null);
    const [ DisplayScale, setDisplayScale ] = useState(1);
    const [ ActiveObj, setActiveObj ] = useState(null);

    const [ TimingStart, setTimingStart ] = useState(null);
    const [ TargetTimes, setTargetTimes ] = useState([]); 
    const [ AnnotationTimer, setAnnotationTimer ] = useState(null); 
    const [ PauseStartTimer, setPauseStartTimer ] = useState(null); 
    const [ RampStartTimer, setRampStartTimer ] = useState(null); 
    const [ RampRestartTimer, setRampRestartTimer ] = useState(null); 
    const [ EndPauseTimer, setEndPauseTimer ] = useState(null); 
    const [ StartMockTimer, setStartMockTimer ] = useState(null); 
    const [ DetectRefresh, setDetectRefresh ] = useState(0); 
    //const [ DetectStart, setDetectStart ] = useState(null); 

    useEffect(() => {
        //var canvas = document.getElementById('mock_canvas');
        var canvas = document.querySelector('#mock_input');

        console.log("Mock.197:  ############  <MOCK> INIT     replay=",props.Replay);
        //setupVimeoPlayer();

        window.addEventListener('resize', adjustMockDisplay);
        window.addEventListener("orientationchange", adjustMockDisplay);
        canvas.addEventListener('touchstart', handleTouchStart, false);
        canvas.addEventListener('touchend', handleTouchEnd, false);
        canvas.addEventListener('mousedown', handleTouchStart, false);
        window.addEventListener('keydown', handleKeyDown, false);
        //canvas.addEventListener('touchstart', handleTouchStart, {once: true});
        //canvas.addEventListener('mouseup', handleTouchEnd, false);

        INFO.mock_detects  = [];
        INFO.mock_player  = null;

        return function cleanup() {
            console.log("Mock.90:   CLEANUP MOCK Mode.....", Refresh);
            clearMockState();

            setShowWarning(false);
            window.removeEventListener('resize', adjustMockDisplay);
            window.removeEventListener("orientationchange", adjustMockDisplay);
            canvas.removeEventListener('touchstart', handleTouchStart, false);
            canvas.removeEventListener('touchend', handleTouchEnd, false);
            canvas.removeEventListener('mousedown', handleTouchStart, false);
            window.removeEventListener('keydown', handleKeyDown, false);
            //canvas.removeEventListener('touchstart', handleTouchStart, {once: true});
            //canvas.removeEventListener('mouseup', handleTouchEnd, false);
            cleanUp();      // remove all targets
        }
    }, [1]);


    useEffect(() => {
        //console.log("mock.62:   ..... Mock Refresh   ");
    }, [Refresh, Target, StarCnt]);




    // main starting point to start detect session
    //     - video needs to be ready (vimeo in seek state)
    //
    useEffect(() => {
        var player = INFO.mock_player;

        console.log("mock.234:         ~ ~ ~ ~ ~ USE_EFFECT    DetectRefresh=",DetectRefresh," start=",INFO.mock_video_seek, " round=",INFO.mock_rounds);
        if(INFO.mock_player) {
            if (INFO.mock_rounds > 0) {
                console.log("mock.236:                   STARTING PLAYER FROM REFRESH!  state=",player.getPlayerState());
                //player.setTime(INFO.mock_video_seek);
                player.start();     // First round we start() after player click start (in startMock())
            }
        }

    }, [DetectRefresh]);



    useEffect(() => {
        //var is_vimeo = (props.SelectedItem.url.includes("youtu") === true) ? false : true;
        //setVimeoType(is_vimeo);
        //console.log("video_ready.153:        ~~~~~~~~~~~~  VIDEO IFRAME READY  url=", props.SelectedItem.url, " is_vimeo=",is_vimeo);

        if(props.Replay === true) {
            var warnings = [], warning = {};
            warning.title = "ERROR: ";
            warning.value = "NONE!";
            warnings.push(warning);
            setShowWarning(false);
            setWarningText(warnings);
            setShowSteps(false);
            setShowTutorial(false);

            var outputs = [];
            var out1 = {};
            out1.title = "0 SETS:";
            out1.value = "0 REPS EACH";
            outputs.push(out1)
            setInstrns(outputs);
            setTargetSize(15);

            var scale = 0.5;
            setDisplayScale(scale)
            setReplay(true)
            console.log("Mock.95:   INIT START MOCK REPLAY MODE.... scale=",scale);
        } else {
            setTargetSize(60);
        }

    }, [props.Replay]);     // Note: Not working yet, came from <Game>



    useEffect(() => {
        if (props.Mode === "run") {
            if (props.MockStarted > 0) {
                //
                // initialize after video is ready
                //
                INFO.drill_param1 = parseSliceParams(props.SelectedItem.param1);
                console.log("Mock.299:    ************************* START MOCK RUN ************************  mock_type=", INFO.mock_type);
                setShowDirection(false); 

                resetMockState("mock_started.286");
                generateMockExecute("mock_started.286");
                //adjustMockDisplay("mock_started.286");      // this screwed up ctx2

                readMockDetects();      // need to have video_id
                setShowSteps(false);
                setupMock();

                startMock();
                //setTimeout(()=>{ startMock() }, 500);       // KLUDGE: wait for vidoe player, should use signal event?

            } else {
                setShowSteps(true);
                cleanUp();
                INFO.mock_running = false;
            }
        }

        setRefresh(Date.now());
    }, [props.MockStarted]);


    useEffect(() => {
        if ((VideoWidth > 0) && (VideoHeight > 0)) {
            console.log("Mock.208:         ~ ~ ~ ~ ~    USE_EFFECT    v.width=",VideoWidth, "  v.height=",VideoHeight);    //VideoPlayer=",VideoPlayer);
            adjustMockDisplay("video_width_chg.304");
        }
    }, [VideoPlayer, VideoWidth, VideoHeight]);


    useEffect(() => {
        console.log("Mock.329:         ~ ~ ~ ~ ~   USE_EFFECT   Footage=",props.Footage);
        if (props.Footage) {
            //setFootage(props.Footage);
            installFootage(props.Footage, "new_footage.332");
            //resetMockState("new_footage.333");    not running a detect
        }

    }, [props.Footage]);


    useEffect(() => {
        console.log("Mock.336:         ~ ~ ~ ~ ~   USE_EFFECT:   MockStarted=",props.MockStarted, "  Mode=",props.Mode);
        switch (props.Mode){
            case "edit":
                setShowDirection(false);
                setTimeout(()=> { 
                    console.log("Mock.369:            . . .  WAKEUP:  ADJUST MOCK  MockStarted=",props.MockStarted, "  Mode=",props.Mode);
                    adjustMockDisplay("select_item.edit.341");
                    initAnnotateContext("select_item.edit.348");
                }, 500)
                break;
            case "play":
                if ((props.MockStarted > 0)) {
                    setShowDirection(false);

                    if (props.SelectedItem){
                        console.log("Mock.244:      ~ ~ ~ ~ ~   NEW VIDEO - RESET STATE  url=",props.SelectedItem);
                        resetMockState("select_item.311");
                        generateMockExecute("select_item.311");

                        readMockDetects();      // need to have video_id
                        adjustMockDisplay("select_item.play.311");
                        initAnnotateContext("select_item.play.361");
                        //setVideoHash(props.SelectedItem.video_hash);
                        setTimeout(()=> { }, 10)
                    }
                }
                break;
        }
    }, [props.MockStarted, props.Mode]);


    useEffect(() => {
        switch (props.Mode) {
            case "run":
                setShowEdit(false);
                break;
            case "edit":
                setShowEdit(true);
                break;
        }
    }, [props.Mode]);



    useEffect(() => {
        //if (props.Mode === "edit"){

    }, [props.SelectedItem, EditMode]);


    useEffect(() => {
        if(props.VideoWidth > 0) setVideoWidth(props.VideoWidth);
        if(props.VideoHeight > 0) setVideoHeight(props.VideoHeight);

    }, [props.VideoWidth, props.VideoHeight]);




    //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    //   MAIN STATE MANAGEMENT ROUTINES
    //

    function cleanUp() {
        clearMockState();

        if (StartMockTimer !== null) {
            clearTimeout(StartMockTimer);      // get rid of old one
        }
        if (AnnotationTimer !== null) {
            clearTimeout(AnnotationTimer);      // get rid of old one
        }
        if (PauseStartTimer !== null) {
            clearTimeout(PauseStartTimer);      // get rid of old one
        }
        if (RampStartTimer !== null) {
            clearTimeout(RampStartTimer);      // get rid of old one
        }
        if (EndPauseTimer !== null) {
            clearTimeout(EndPauseTimer);      // get rid of old one
        }
        if (RampRestartTimer !== null) {
            clearTimeout(RampRestartTimer);      // get rid of old one
        }
        if (AnnotationTimer !== null) {
            clearTimeout(AnnotationTimer);      // get rid of old one
        }

        //console.log("mock.171:      ENTER TARGET CLEAN UP...  ", INFO.mock_target.length);
        /*
        for(var i = 0; i < INFO.mock_target.length; i++ ) {
            //console.log("mock.173:      CLEAN UP TARGET.",i,"...  ", INFO.mock_target[i]);
            INFO.mock_target[i].stop();   // remove previous target objects;
            INFO.mock_target[i].destroy();   // remove previous target objects;
        }
        */
    }



    // UTIL
    //     - "run mode": 
    //     - "edit mode": need to extract url and player type from hash
    //
    function installFootage(footage, from) {
        var url = null;

        if (footage.source) {
            url = makeFootageVideoLink(footage, "read_mock_detects.367");
            //source = footage.source;
        } else {

            /*  EDIT FOOTAGE
            action: "video"
            height: 720
            subtype: "mock"
            title: "lamo-u17-8"
            type: "footage"
            value: "foot:vimeo:657633486"
            video_id: 657633486
            width: 1280
            */

            var hash = footage.value;
            var [ video_id, video_start, video_end, type ] = decodeVideoHash(hash);
            footage.video_hash = hash;
            footage.video_id = video_id;
            footage.video_start = video_start;
            footage.video_end = video_end;
            footage.source = type;
            url = makeFootageVideoLink(footage, "read_mock_detects.367");
        }
        INFO.video_url = url;

        console.log("mock.365:    # # # # #  INSTALL FOOTAGE   from=",from, " url=",url, " footage=",footage);
        INFO.footage_width = footage.width;
        INFO.footage_height = footage.height;
        INFO.mock_timeline = footage.timeline;

        INFO.mock_video_hash = footage.hash;        // in case no detects yet
        INFO.mock_video_id = (footage.video_id).toString();
        INFO.video_start = footage.start;
        INFO.video_end = footage.end;

        //setVideoWidth(footage.width);
        //setVideoHeight(footage.height);
        setPlayerType(footage.source);
        setFootage(footage);
        //setVideoHash(footage.hash)
    }


    // Put the new Detects in place
    //     - INFO.mock_detects
    //
    function installDetects(footage, all_detects) {
        if(!all_detects) {
            console.log("mock.378:    !!!!!!!!!!!! WILL WIPEOUT DB -   BAD ALL_DETECTS!! ",all_detects);
            //all_detects = createNewDetect(footage);
            INFO.mock_all_detects = [];
            INFO.mock_detects = [];
            return;
        }
        INFO.mock_all_detects = {...all_detects};

        // KLUDGE: VERY CONFUSING, WHICH ONE IS RIGHT?
        //INFO.mock_detects = INFO.mock_all_detects;
        INFO.mock_detects = [];
        var detects = INFO.mock_detects;    // ptr to setup mock_detects
        for (var id in CONSTS.MOCK_TYPES) {
            var field = CONSTS.MOCK_TYPES[id];
            detects[field] = [];
            if (all_detects[field] !== undefined) {
                detects[field] = JSON.parse(JSON.stringify(all_detects[field]));      // deep copy array of objects
                console.log("mock.409:               . . . . DB  field=",field, "  detects[field]=",detects[field]);
            }
        }


        INFO.mock_detects = {...all_detects};       // 
        //INFO.mock_detects = {...all_detects[INFO.mock_type]};


        console.log("mock.383:     INSTALL DETECT ",all_detects);
        INFO.mock_video_hash = all_detects.video_hash;
        console.log("mock.338:           .  .  .  .    INSTALL MOCK DETECTS  id=",INFO.mock_video_id, " mock_video_hash=",INFO.mock_video_hash,"  ",INFO.mock_detects);
        //resetMockState("db_read.342");
        //generateMockExecute("db_read.342");

        handleMockMetadataReady();
    }


    // create new DB Detect entry 
    //
    function createNewDetect(footage) {
        var type = (INFO.youtube_player === true) ? "youtube" : "vimeo";
        var mock_video_hash = "foot:"+type+":"+INFO.mock_video_id;

        var body = {};
        body.video_id = INFO.mock_video_id;
        body.video_hash = mock_video_hash;
        body.timeline = footage.timeline;
        body.src = footage.source;
        for (var id in CONSTS.MOCK_TYPES) {
            var field = CONSTS.MOCK_TYPES[id];
            body[field] = [];
        }
        INFO.mock_video_hash = mock_video_hash;
        CreateDetect(mock_video_hash, body);   // create a new detect for this video
        return body;
    }



    // read simulation metadata, create one if none
    //     - To avoid repeats, read form video footage "stream"
    //     - server check the last user detect run and continue after that
    //
    function readMockDetects() {
        var item = props.SelectedItem;
        var mock_type = (INFO.mock_edit_mode === true) ? "_edit_" : INFO.mock_type;

        var type = (true) ? "_edit_" : INFO.mock_type;
        ReadFootageDetect(INFO.user_id, type)   // read footage & detect from db
        .then((res) => {
            console.log("read_mock.357:             .  .  .  .   MOCK receive_db_detect   res=",res);
            if (res === undefined) {
                return;
            }

            var tot_footages = res.footages;
            var tot_detects = res.detects;
            INFO.mock_tot_footages =  [...tot_footages];
            INFO.mock_tot_detects = [...tot_detects];
            INFO.mock_footage_idx = 0;      // starting footage

            var footage = tot_footages[INFO.mock_footage_idx];
            var timeline = footage.timeline;
            setFootages(tot_footages);
            installFootage(footage, "read_mock_detect.527");

            var all_detectz = tot_detects.filter(detect => { return detect.timeline == timeline});
            var all_detects = all_detectz[0];
            installDetects(footage, all_detects);
            resetMockState("read_detect.478");
            var status = generateMockExecute("read_detect.478");
            console.log("read_mock.325:             .  .  .  .   MOCK receive_db_detect   footage=",res.footages, " mock_type=",INFO.mock_type);    //,"   all_detects=",all_detects);

            if (status === null) {
                // no detect for this drill!  PUNT!
                //
                console.log("read_mock.527:            !!!!!!!!!!!!! STOP:  HAS NO DETECTS FOR ", INFO.mock_mode);
                props.Finished("error");
            }

            /*
            if(all_detects === undefined ) {
                createNewDetect(footage);
                INFO.mock_all_detects = [];
            } else {

                // return the same metadata type
                //
                //installDetects(footage, all_detects);
            }
            */
        })

    }



    // clear up temp state, get it ready for next run
    //    - CREATES mock_execute[]
    //
    function resetMockState(from) {

        INFO.mock_session_running = false;      // start only after video is going
        INFO.mock_video_seek = null;
        INFO.mock_show_timer = false;
        INFO.mock_start_time = null;
        INFO.drill_stars = 0;

        TIMES.mock_reacted = [];
        TIMES.mock_show_target = [];
        INFO.mock_execute = [];     // random list to excute
        INFO.mock_target_idx = 0;     // random list to excute
        //INFO.mock_edit_mode = false;      // not here

        INFO.annotate = null;      //secondary buffer
        initAnnotateContext("reset_mock.390");
        console.log("mock.324:        ------------------------  RESET MOCK STATE   from=",from, " type=",INFO.mock_type," execs=",INFO.mock_execute);    //, " ctx0=",INFO.annotate.ctx0.canvas);
        //generateMockExecute(from);

        return;
    }



    // load detect list for the type if avail
    //    - expect INFO.mock_detects[] to be set
    //
    function generateMockExecute(from) {
        var detect = null;

        INFO.mock_execute = [];     // make sure this has latest or nothing
        var detects = INFO.mock_detects;
        if (detects[INFO.mock_type] !== undefined) {
            var cnt = createDetectList();
            if (cnt !== null) {
                INFO.mock_target_idx = 0;
                detect = INFO.mock_execute[0];
                console.log("mock.570           .  .  .  .  NEW MOCK_EXEC LIST CREATED:  ",INFO.mock_execute); //, INFO.mock_player);
            } else {
                console.log("mock.1104           .  .  .  .  ResetMock: STILL NO Mock metadata!   ",INFO.mock_detects); //, INFO.mock_player);
                detect = null;
            }
        } 

        return detect;
    }



    // completely wipe out mock state
    //
    function clearMockState() {
        INFO.out_canvas = null;
        INFO.out_context = null;
        INFO.prime_canvas = null;
        INFO.prime_context = null;
        INFO.annotate = null;

        INFO.mock_target_idx = 0;     // random list to excute
        INFO.mock_rounds = 0;
        INFO.mock_execute = [];     // random list to excute
        TIMES.mock_reacted = [];
        TIMES.mock_show_target = [];
        //INFO.mock_detects = [];
        //INFO.mock_target = [];     // random list to excute

        INFO.mock_start_time = null;        // old?
        INFO.mock_show_timer = false;       // old?
        INFO.mock_edit_mode = false;
        //INFO.mock_custom_speed = null;      // for this drill
        //INFO.mock_custom_leader = null;     // for this drill

        //INFO.mock_player = null;
        //INFO.mock_all_detects = null;
        //INFO.mock_video_id = null;
        console.log("mock.607        .  .  .  .  MOCK STATE CLEARED");
    }


    // setup the mock screens before starting
    //
    function setupMock() {
        var display = document.querySelector('#drill_video_container');
        //var canvas = document.querySelector('#drill_output');
        var ww = display.offsetWidth;
        var hh = display.offsetHeight;
        //ctx.clearRect(0, 0, ww, hh);    // clear canvas
        //ctx.fill();

        console.log("mock.624:  SETUP MOCK   ww=",ww, " hh=",hh);
    }


    // UTIL
    // centralized routine to find the starting point depending on mock_mode
    //     - leader is in real duraton time (msec)
    //     - return value still in video time
    //
    function calcDetectEndpoints(video_start, video_end, run_mode, clean) {
        //var leader = (INFO.mock_custom_leader) ? parseFloat(INFO.mock_custom_leader) : CONSTS.MOCK_DISPLAY_TIMER;
        var leader = (INFO.drill_param1) ? parseFloat(INFO.drill_param1.leader) : CONSTS.MOCK_DISPLAY_TIMER;
        var vleader = convertVideoTime(leader);     // account for playing speed
        var vstart = parseFloat(video_start);
        var vend = parseFloat(video_end);
        var start = vstart, end;
        switch (run_mode) {
            case "gun":
                start = vstart - CONSTS.MOCK_DISPLAY_BEFORE_SEC;    // gun: after everything
                end = vend + CONSTS.MOCK_DISPLAY_AFTER_SEC;         // gun: after everything
                break;
            case "timer":
                if (clean === true) {
                    start = vstart;    // timer: after everything
                } else {
                    start = vstart - (vleader / 1000) - CONSTS.MOCK_LOADING_DELAY_SEC;    // timer: after everything
                }
                end = vend + CONSTS.MOCK_DISPLAY_AFTER_SEC;    // timer: after everything
                break;
        }
        INFO.mock_debug && console.log("mock.627:       DETECT START  leader=",leader, " vleader=",vleader, " clean=",clean, " v.start=",video_start, " start=",start, " end=",end, " v.end=",video_end);
        //console.log("mock.943:       .  .  .  .  CALC DETECT START  mode=",run_mode, " leader=",leader, " vleader=",vleader, " clean=",clean, " v.start=",video_start, " start=",start, " end=",end, " v.end=",video_end);
        start = (start < 0) ? 0 : start;

        return [ start, end, (leader / 1000) ];     // everything is in seconds
    }


    function findMockRunMode(mock_type) {
        var mode = null;
        switch (mock_type) {
            case "comment":
                //gun_mode = true;
                mode = "gun";
                break;
            case "target":
                //gun_mode = true;
                mode = "gun";
                break;
            case "path":
                //timer_mode = true;
                mode = "timer";
                break;
            case "passing":
                //timer_mode = true;
                mode = "timer";
                break;
            case "position":
                //gun_mode = true;
                mode = "gun";
                break;
        }
        return mode;
    }




    // main entry for video simulation session
    //   - make sure video player is ready b4 this is called
    //
    function startMock() {
        var player = INFO.mock_player;
        if ((player === null) || (player === undefined)) {
            console.log("mock.520:         !!!!!!!!!!! ERROR: StartMock()  DOES NOT HAVE VALID PLAYER...WAITING   time=",Date.now()%100000/1000," footage=", Footage);
            var timer = setTimeout(()=>{ startMock() }, 200);       // KLUDGE: wait for vidoe player, should use signal event?
            setStartMockTimer(timer);
            // need to save timer?
            return;     // return here?
        }
        console.log("mock.710:        +++++++++++++ StartMock()  HAS VALID PLAYER...  time=",Date.now()%100000/1000," footage=", Footage);
        setShowVideo(true);

        //clearMockState();     // not good idea?
        //*
        INFO.mock_session_running = false;      // start only after video is going
        INFO.mock_show_timer = false;
        INFO.drill_stars = 0;

        TIMES.mock_reacted = [];
        TIMES.mock_show_target = [];
        /**/


        /*
        //INFO.mock_start_time = null;
        INFO.mock_video_seek = null;
        INFO.mock_execute = [];     // random list to excute
        INFO.mock_target_idx = 0;     // random list to excute
        */


        TIMES.mock_perf_react = [];
        TIMES.mock_perf_good = [];
        TIMES.mock_perf_bad = [];
        TIMES.timer_stop_display = 0;   // for displaying warning msgs
        TIMES.session_start = Date.now();   // each finger run is a session
        INFO.notify_messages = [];      // KLUDGE: This should be init earlier

        INFO.mock_press_cnt = 0;
        INFO.mock_rounds = 0;
        INFO.mock_press_valid = false;
        INFO.mock_running = true;

        var warnings = getPersonalTarget();
        if (warnings !== null) {
            setShowPreFlight(true);
            setWarningText(warnings);
            setTimeout(()=>{ setShowPreFlight(false) }, 3000)
        }


        //var detect = INFO.mock_execute[0];
        var active = INFO.mock_execute[0];
        var mode = findMockRunMode(INFO.mock_type);
        var clean = player.paused || INFO.mock_edit_mode;
        var [start, end, leader] = calcDetectEndpoints(active.start, active.end, mode, clean);
        //var start = (detect === undefined) ? INFO.video_start : detect.start;
        INFO.mock_detect_time = start;       // remember the video start time (for future)

        INFO.mock_playing_speed = (INFO.drill_param1) ? INFO.drill_param1.speed : 0.81;
        console.log("mock.763:    + + + + + + + + + + + + +  StartMock VIDEO IS MOVING   speed=",INFO.mock_playing_speed, " start=",start," exec=",INFO.mock_execute," time=",parseInt(performance.now()));

        // ONLY START DETECT SESSION AFTER THE VDEO IS PLAYING!!!
        //
        switch (INFO.mock_type) {
            case "comment":
                //setDetectStart(start);
                INFO.mock_video_seek = start;
                setDetectRefresh(DetectRefresh+1);
                break;
            case "target":
            case "path":
                INFO.mock_video_seek = start;
                setDetectRefresh(DetectRefresh+1);
                break;
            case "passing":
            case "position":
                INFO.mock_video_seek = start;
                setDetectRefresh(DetectRefresh+1);
                break;
        }

        //player.pause();     // in startMock(),  Do we need this?
        player.setTime(INFO.mock_video_seek); 
        player.setSpeed(INFO.mock_playing_speed); 
        player.mute();
        player.start();     // in startMock(),  Do we need this?

        //cleanUp();
        //newTarget(true);
        clearRUNS();
        console.log("mock.200: SIMULATION STARTED...      mock_type=",INFO.mock_type);
    }




    // main entry to check if game has ended;
    //
    function endMock(mode) {
        //console.log("game.308: STOPPING GAME?  round=",INFO.game_rounds, "  mode=",mode, "  target=", INFO.game_target.length);
        cleanUp();
        switch (mode) {
            case "interrupt":
                INFO.mock_running = false;
                props.Finished(mode);
                return true;
            case "error":
                INFO.mock_running = false;
                props.Finished(mode);
                return true;
            default:
                INFO.mock_running = false;
                props.Finished(mode);
                return true;

                if(INFO.mock_rounds > CONSTS.MOCK_MAX_CNT) {
                } else {
                    return false;
                }
                break;
        }
    }




    // offset_width: https://stackoverflow.com/questions/21064101/understanding
    //      -offsetwidth-clientwidth-scrollwidth-and-height-respectively
    //
    const adjustMockDisplay = (from) => {
        var hh, ww;

        if ((INFO.footage_width === null) || (INFO.mock_player === null)) {
            console.log("adjust_mock_display.930:        NO MOCK ADJUST.....  from=",from, " footage_width=",INFO.footage_width, "  mock_player=",INFO.mock_player);
            return;     // db data not in yet 
        }

        //var display = document.getElementById('mock_root');
        //var canvas = document.getElementById('mock_canvas');
        var display = document.querySelector('#drill_video_container');
        //var player = document.querySelector('#drill_output0');        // bad
        var player = document.querySelector('#drill_output');       // <canavs> inside <VideoPlayer>
        var input = document.querySelector('#mock_input');
        var canvas = document.querySelector('#mock_buffer0');
        var buffer = document.querySelector('#mock_buffer1');

        //var cww = display.offsetWidth;
        //var chh = display.offsetHeight;
        var dww = display.clientWidth;  // - props.SidebarWidth;
        var dhh = display.clientHeight; // - 50;
        var dratio = dww / dhh;

        //var vww = props.SelectedItem.width;
        //var vhh = props.SelectedItem.height;
        var vww = INFO.footage_width;
        var vhh = INFO.footage_height;
        var vratio = vww / vhh;

        hh = dhh;           // alwasy in horizontal mode
        ww = dhh * vratio;
        if (ww > dww) {
            ww = dww;
            hh = dww * ( 1 / vratio);
        }
        ww = parseInt(ww.toFixed(0));
        hh = parseInt(hh.toFixed(0));

        // sb.wd= undefined  d.cww= 467  d.chh= 0  dratio= Infinity  s.ww= 1280  s.hh= 720  vratio= 1.778  d.ww= 0  d.hh= 0

        //console.log("mock_display.968:    MOCK DIMS    from=",from, "   sb.wd=",props.SidebarWidth, " d.cww=",display.clientWidth, " d.chh=", display.clientHeight, 
        //    " dratio=", dratio.toFixed(3), " s.ww=", INFO.footage_width, " s.hh=", INFO.footage_height, " vratio=", vratio.toFixed(3), " d.ww=", ww, " d.hh=", hh);

        if ((ww === 0) || (hh === 0)) {
            return;     // something not right, don't adjust
        }

        //var is_vimeo = (props.SelectedItem.url.includes("youtu") === true) ? false : true;
        //var yhh = (INFO.mock_player.type === "youtube") ? parseInt(hh) + 400 : hh;     // KLUDGE: HIDE YOUTUBE "play next"
        var yhh = hh;
        INFO.kludge_youtube_height = 0;
        if (INFO.mock_player.type === "youtube") {
            INFO.kludge_youtube_height = 400;
            yhh = parseInt(hh) + INFO.kludge_youtube_height;     // KLUDGE: HIDE YOUTUBE "play next"


            /* NOTE: NEED FIGURE OUT WHY EXTRA 140 ?!?!?
            INFO.annotate.offset_y = 0;
            if (INFO.annotate.height > 540) {
                INFO.annotate.offset_y = (INFO.kludge_youtube_height - 140);  // let the annotate know to make Y adjustment
            }*/

        }

        console.log("adjust_mock_display.352:      ADJUST MOCK   from=",from, " vww=",vww, " vhh=",vhh, " vratio=",vratio.toFixed(3), "  dww=",dww, " dhh=",dhh, " dratio=",dratio.toFixed(2));
        console.log("adjust_mock_display.354:   ------ MOCK DISPLAY d.width=",display.clientWidth, " sidebar_w=",props.SidebarWidth," d.height=",display.clientHeight, " ww=",ww, " hh=",hh);

        //canvas.width = ww;      // VERY IMPORTANT TO SET CANVAS SIZE!!!
        //canvas.height = hh;       // should we skip this?
        input.width = ww;
        input.height = hh;
        canvas.width = ww;
        canvas.height = hh;
        buffer.width = ww;
        buffer.height = hh;
        if(player !== null) {
            player.style.width = ww.toString()+"px";
            player.style.height = yhh.toString()+"px";          // MEGA KLUDGE: #drill_output  use yhh to WORK AROUND YOUTUBE "play next"
            //player.style.height = hh.toString()+"px";
        }

        if(canvas !== null) {
            canvas.style.width = ww.toString()+"px";
            canvas.style.height = hh.toString()+"px";       // Note: do not use video ht!!!
        }

        if(buffer !== null) {
            buffer.style.width = ww.toString()+"px";
            buffer.style.height = hh.toString()+"px"; 
        }

        if(INFO.annotate !== null) {
            console.log("adjust_mock_display.387:   ------ MOCK SET EXISTING ANNOTATE   width=",ww, " height=",hh);    //, "  ctx0=",INFO.annotate.ctx0.canvas);
            INFO.annotate.ctx_width = ww;
            INFO.annotate.ctx_height = hh;
        }

        setVideoWidth(ww);      // for <Youtube>
        setVideoHeight(yhh);
        INFO.video_width = ww;
        INFO.video_height = hh;
        console.log("adjust_mock_display.333:        .  .  .  .  ADJUST MOCK CANVAS  from=",from, " type=",PlayerType, "  c.wd=",canvas.width, " c.ht=",canvas.height, " d.ww=",ww," d.yhh=",yhh, " s.vhh=",vhh, " s.vww=",vww);
    }



    // setup next target
    //    - return the actual detect (from exec)
    //
    const startNextMockTarget = () => {
        var all_detects = null, detects = null;
        var idx0 = INFO.mock_target_idx;
        var idx = idx0 + 1;

        if (idx < INFO.mock_execute.length) {
            INFO.mock_target_idx = idx;
            detects = INFO.mock_execute[idx];   // existing
            return detects;

        } if (INFO.mock_edit_mode === false) {  // do not auto-switch footage in edit mode
            var fidx0 = INFO.mock_footage_idx;

            //if (fidx < INFO.mock_tot_footages.length) {
            for (var fidx = (fidx0 + 1); fidx < INFO.mock_tot_footages.length; fidx++) {
                // try next footage
                //
                //INFO.mock_player = null;        // need to get a new one
                INFO.mock_footage_idx = fidx;
                var footage = INFO.mock_tot_footages[fidx]
                var timeline = footage.timeline;

                var all_detectz = INFO.mock_tot_detects.filter(detect => { return detect.timeline == timeline});
                all_detects = all_detectz[0];

                console.log("read_mock.956:             . . . .  FOOTAGE+DETECT  fidx=",fidx);  //, " all_detects=",all_detects) ;
                if (all_detects && all_detects[INFO.mock_type][0]) {
                    INFO.mock_target_idx = 0;

                    installFootage(footage, "start_next_mock.967");
                    installDetects(footage, all_detects);
                    resetMockState("end.startmock.920");
                    generateMockExecute("end.startmock.920");

                    detects = INFO.mock_execute[0];
                    console.log("read_mock.325:             . . . . **** GOT NEXT FOOTAGE+DETECT  fidx=",fidx, " source=",footage.source, "  detects=",detects, " all_detects=",all_detects) ;
                    //startDetectRun();
                    return detects;
                }

                // keep going until we find a good detects
            }
        }

        console.log("mock.883:     !!!!!!!! NO MORE FOOTAGE WITH DETECTS!   type=",INFO.mock_type, "  round=", INFO.mock_rounds, " exec=",detects);
        return null;



        //INFO.mock_targets = [];      // clear old stuff
        //INFO.mock_rounds = INFO.mock_rounds + 1;
        if (endMock("save") == false) {
            //INFO.mock_targets = [];      // clear old stuff
        }

    }





    //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    //   CANVAS ANNOTATION ROUTINES
    //

    //     - NOTE: Caller must use "await"
    //     - WARNING: ***** CAN NOT ACCESS REACT VARS INSIDE TIMEOUT TRIGGER ROUTINES! ****
    //     - NOTE: **** DISPLAY ROUTINE ARE TIME SENSITIVE! DO NOT BLOCK!! ****
    //
    const TIMER_XOFFSET0 = "-26%"   // per drill time (no star)
    const TIMER_XOFFSET1 = "-50%"   // center film time
    const TIMER_XOFFSET2 = "-35%"    // per drill (with star)
    const ANSWER_SIZE = 25;
    const TITLE_SIZE = 12;
    const FILM_TIME_SIZE = 14;
    async function displayEditMode(curr) {
        var player = INFO.mock_player;
        if ((player === null) || (INFO.annotate === null)) {
            //console.log("mock.1013:     !!!!! NO Analysis Annotate     annotate=", INFO.annotate, "  playaer=",INFO.mock_player);
            return;
        }

        var Annotate = INFO.annotate;
        var mode = findMockRunMode(INFO.mock_type);

        /* DEBUG: CALIBRATION MARK
        var bsize = 4;
        var color = "pink";
        Annotate.draw_block(color, "0%", "0%", bsize, bsize);
        Annotate.draw_block(color, "25%", "25%", bsize, bsize);
        Annotate.draw_block(color, "50%", "50%", bsize, bsize);
        Annotate.draw_block(color, "75%", "75%", bsize, bsize);
        Annotate.draw_block(color, "100%", "100%", bsize, bsize);*/


        // show running time
        //
        INFO.mock_debug && console.log("mock.992:       SHOW EDIT MODE  curr=", curr, " targets=",TIMES.mock_reacted.length, " detects=",INFO.mock_detects.length);  //, " detects=",detects, " anno=",Annotate);
        Annotate.draw_text("#eeeeee80", "#00000048", FILM_TIME_SIZE, curr.toFixed(3) +" sec", TIMER_XOFFSET1, "+0.5%");   // film duration

        // display raw unprocess clicks (partial sequence)
        //
        var clicks = TIMES.mock_reacted;
        if ((clicks !== null) && (clicks.length > 0)) {

            for(var i = 0; i < clicks.length; i++) {
                var click = clicks[i];

                var elapse = (curr - click.video_time) * 1000;   // from start move
                var delta = click.video_time - INFO.mock_start_time;   // actual click
                delta = parseInt((delta) * 1000);
                var x = click.x+"%";
                var y = click.y+"%";        // Note: this does not work for youtube vids, need to minus the offsets

                INFO.mock_debug && console.log("mock.727:       SHOW EDIT  i=", i, " x=",x, " y=",y, "  click=",click);       //, " ", Annotate.ctx1.canvas);
                //Annotate.draw_text("yellow", null, 13, i+": "+CONSTS.MOCK_TYPE_TITLES[INFO.mock_type], "+1%", "+0.5%");   // title
                if (i === 0) {
                    //console.log("annotate.490:            ",i,":  elapse=", elapse, " type=",INFO.mock_type);
                    if ((elapse >= CONSTS.MOCK_DISPLAY_BASE) && (elapse <= 50)) {
                        Annotate.draw_ellipse("#ffd40052", "#ff000040", 1, x, y, 20, 6);
                    }
                } else {
                    //console.log("annotate.478:            ",i,":  elapse=", elapse, " x=",x, " y=",y);
                    if ((elapse <= CONSTS.MOCK_DISPLAY_LABEL) && (elapse >= -50)) {
                        Annotate.draw_text("yellow", null, 10, delta+" msec", x, y);
                    }
                }
            }
        }


        // EDIT: display defined detect runs
        //
        var detects = INFO.mock_detects[INFO.mock_type];
        //INFO.mock_debug && console.log("mock.583:  DISPLAY MEASURE...INFO.mock_detects=",detects)
        if ((detects !== undefined) && (detects !== null) && (detects.length > 0)) {
            //console.log("annotate.571:            ",i,":  curr=",curr, " active=",detects);
            var max = detects.length;
            for(var i = 0; i < detects.length; i++) {
                var active = detects[i];
                var [start, end, leader] = calcDetectEndpoints(active.start, active.end, mode, INFO.mock_edit_mode);
                //console.log("annotate.571:            ",i,":  curr=",curr, " active=",active);

                if ((INFO.mock_type !== active.type)) {
                    continue;
                }

                //var start = active.start - (CONSTS.MOCK_DISPLAY_PREVIEW/1000);
                //if ((curr >= start) && (curr <= active.end)) {
                //if ((curr >= start) && (curr <= active.end)) {
                //INFO.mock_debug && console.log("mock.961:      . . . .  EDIT TITLE   detect.i=",i," curr=",curr, " start=",start, " end=",end, " mode=",mode);
                if (curr >= (start - (CONSTS.MOCK_DISPLAY_PREVIEW/1000)) && (curr <= end)) {
                    Annotate.draw_text("yellow", null, TITLE_SIZE, CONSTS.MOCK_TYPE_TITLES[active.type]+ " ("+(i+1)+"/"+max+")", "+1%", "+0.5%");   // title

                    // show PER DETECT TIMER
                    //
                    var now = (curr - start).toFixed(3);
                    if (mode === "gun") {
                        // gun mode
                        if (curr <= active.end) {
                            var color0 = (now <= 0) ? "#ff0000b0" : "#179b36b0";
                            Annotate.draw_text(color0, "#ffffff40", 16, now +" sec", TIMER_XOFFSET0, "+0.5%");   // elapse time
                        }
                    } else {
                        // timer mode
                        var now1 = (curr - active.start).toFixed(3);
                        //if ((curr <= active.start) && (curr <= end)) {
                        if (curr <= end) {
                            var color0 = (now1 <= 0) ? "#179b36b0" : "#ff0000b0";
                            Annotate.draw_text(color0, "#ffffff40", 16, -now1 +" sec", TIMER_XOFFSET0, "+0.5%");   // elapse time
                        }
                    }

                    // TARGET: show expected click endpoints motion prorated by time
                    //
                    if ((INFO.mock_type === "target") && (curr >= start) && (curr < active.end)) {
                        var [newx, newy] = interimTargetCoord(curr, active);
                        var actual1 = active.points[1];
                        var actual2 = active.points[2];
                        var colort = (curr >= active.start) ? "#ffffff30" : "#66666620";
                        Annotate.draw_ellipse("#00ff0022", "#00ff0040", 2, actual1.x+"%", actual1.y+"%", 10, 10);
                        Annotate.draw_ellipse("#ff000022", "#ff000040", 2, actual2.x+"%", actual2.y+"%", 10, 10);
                        Annotate.draw_ellipse(colort, "#33333320", 2, newx+"%", newy+"%", 10, 10);
                        //INFO.mock_debug && console.log("mock.801:       colort=",colort, " curr=",curr, " a.start=",active.start, " end=",end);
                    }

                    // show starting symbol
                    //
                    var points = active.points;
                    var x = points[0].x+"%";
                    var y = points[0].y+"%";
                    var base = points[0].time;
                    if ((curr - active.start) < 0.080) {
                        //console.log("annotate.587:            ",i,":  TARGET0 TEXT curr=",curr, " e1=",elapse1, " e2=",elapse2, " active=",active);
                        Annotate.draw_ellipse("#ffd40010", "#ff000030", 1, x, y, 20, 6);    // yellow starting marker
                    }

                    // display per-target markings
                    //
                    var label="";
                    for (var idx = 1; idx < points.length; idx++) {
                        var point = points[idx];
                        var elapse0 = parseInt((base - active.start) * 1000);
                        var elapse1 = parseInt((curr - active.start) * 1000);
                        var elapse2 = parseInt((active.end - curr) * 1000);
                        var elapse3 = parseInt((point.time - base) * 1000);
                        var elapse4 = parseInt((curr - point.time) * 1000);
                        //var elapse5 = parseInt((curr - active.end) * 1000);
                        x = point.x+"%";
                        y = point.y+"%";

                        var text = false;
                        var circle = false;
                        var target = false;
                        var newx, newy;
                        switch (INFO.mock_type) {
                            case "target":
                                //label = "mark-"+idx;
                                if ((curr >= start) && (curr <= active.end)) {
                                    [newx, newy] = interimTargetCoord(curr, active);
                                    target = true;
                                }
                                if ((idx == 1) && (elapse1 <= CONSTS.MOCK_DISPLAY_LABEL) && (elapse1 >= -50)) { label = "start"; text = true }
                                if ((idx == 2) && (elapse2 <= CONSTS.MOCK_DISPLAY_LABEL) && (elapse2 >= -50)) { label = "end"; text = true }
                                break;
                            case "comment":
                                label = elapse3 + " msec";
                                if ((elapse4 >= 0) && (elapse2 >= 0)) { text = true }
                                break;
                            case "position":
                            case "passing":
                            case "path":
                                label = "mark-"+idx;
                                //if ((elapse1 <= CONSTS.MOCK_DISPLAY_LABEL) && (elapse1 >= -50)) { text = true; circle = true; }
                                if (curr <= active.start) { text = true; circle = true; }
                                break;
                        }

                        //console.log("mock.787:   DISPLAY  curr=",curr, " point.time=",point.time, " base=",base, " active.start=",active.start," active.end=",active.end)
                        if (text === true) Annotate.draw_text("yellow", null, 10, label, x, y, "center");
                        if (circle === true) Annotate.draw_ellipse("#00aa0010", "00dd0020", 1, x, y, ANSWER_SIZE, ANSWER_SIZE);   // #00f000052
                        if (target === true) Annotate.draw_ellipse("#00dd0008", "#00dd0020", 1, newx+"%", newy+"%", ANSWER_SIZE, ANSWER_SIZE);   // #00f000052
                    }

                }
            }
        }  // detect loop

    }



    // display runtime target annotation
    //     - NOTE: Caller must use "await"
    //     - show mode title
    //     - show feedback after single click
    //     - NOTE: **** DISPLAY ROUTINE ARE TIME SENSITIVE! DO NOT BLOCK!! ****
    //
    async function displayTarget(curr) {
        var gun_mode = false, timer_mode = false, mode = null;
        var start, end, leader;
        var Annotate = INFO.annotate;
        var idx0 = parseInt(INFO.mock_target_idx);
        var active = INFO.mock_execute[idx0];  // the detect template
        var t0 = parseInt(performance.now());

        var player = INFO.mock_player;
        if ((player === null) || (active === undefined)) {
            //console.log("mock.1192:     !!!!! FAIL DISPLAY TARGET!!!   show_timer=", INFO.mock_show_timer, "  playaer=",INFO.mock_player);
            return;
        }

        if ((curr > 0) && (player.paused === true)) {
            Annotate.draw_text("#eeeeee80", "#00000048", FILM_TIME_SIZE, curr.toFixed(3) +" sec", TIMER_XOFFSET1, "+0.5%");   // film duration
        }
        INFO.mock_debug && console.log("mock.505:       TARGET SHOW   curr=", curr, " idx0=",idx0, " t_start=",parseInt(INFO.mock_timing_start), " targets=",TIMES.mock_reacted.length, " detects=",INFO.mock_detects.length, " active=",active);  //, " detects=",detects, " anno=",Annotate);

        // show click time (if within window)
        //
        //var curr = await INFO.mock_player.getTime();  // can not use React var here!
        if (active !== null) {
            var velapse = parseInt((curr - active.start) * 1000);   // NEED TO ACCOUNT FOR PLAY SPEED
            var elapse = convertRealTime(velapse);  // duration in real time msec
            elapse = parseInt(elapse);
            var start = null;
            var end = null;

            mode = findMockRunMode(INFO.mock_type);
            gun_mode = (mode === "gun") ? true : false;
            timer_mode = (mode === "timer") ? true : false;
            [start, end, leader] = calcDetectEndpoints(active.start, active.end, mode, player.paused);
            //INFO.mock_debug && console.log("mock.889:       SHOW TARGET0   curr=",curr, " velapse=",velapse, " elapse=",elapse, " active=",active);

            // SHOW TITLE HEADER
            //    - in edit mode show only same type
            //
            var title = CONSTS.MOCK_TYPE_TITLES[INFO.mock_type] + " ("+(idx0+1)+")"
            Annotate.draw_text("yellow", null, TITLE_SIZE, title, "+1%", "+0.5%");   // title
            //INFO.mock_debug && console.log("mock.883:       SHOW TARGET1   curr=",curr, " start=",start, " end=",end,"  exec=",INFO.mock_execute.length);


            // CUE GUN MODE: SHOW PRE-CLICK "START" VISUAL CUE
            //    - Allow click after "green" (disabled)
            //    - used by "target"
            //    - used by "position": 
            //
            if (gun_mode === true) {
                INFO.mock_debug && console.log("mock.1137:       SHOW TARGET2   gun=",gun_mode, " curr=",curr, " elapse=",elapse, " end=",end, " active=",active, "idx0",idx0," time_start=",INFO.mock_timing_start, " show.target=", TIMES.mock_show_target[idx0]);
                if ((elapse >= CONSTS.MOCK_DISPLAY_BASE) && (elapse <= 80)) {

                    var color = null;
                    var x = active.points[0].x+"%";
                    var y = active.points[0].y+"%";
                    //if ((curr >= INFO.mock_timing_start) && (elapse >= CONSTS.MOCK_DISPLAY_GREEN)) 
                    if ((curr >= (active.start + CONSTS.MOCK_DISPLAY_GREEN)) && (elapse >= CONSTS.MOCK_DISPLAY_GREEN)) {
                        // starting gun, set start time *once*
                        //
                        color = "#00f00077"     // green
                        if (TIMES.mock_show_target[idx0] === undefined) {
                            TIMES.mock_show_target[idx0] = t0;
                            console.log("mock.1011:       GUN - SET SHOW TARGET TIME   idx0=",idx0, " time=", TIMES.mock_show_target[idx0], " start=",start, " end=",end);
                        }
                    } else {
                        color = "#f7eb4577";    // yellow
                    }
                    //var color = (elapse >= CONSTS.MOCK_DISPLAY_GREEN) ? "#00f00077" : "#f7eb4577";
                    Annotate.draw_block(color, x, y, 20, 6);  // show yellow, then green visual cue bar
                }
            }


            // CUE TIMER MODE: SHOW PRE-CLICK "TIMER" VISUAL CUE
            //    - Allow multiple click up to end of timer
            //    - HOW DO WE TIME "MULTI-CLICKS"?
            //
            //var vleader = CONSTS.MOCK_DISPLAY_TIMER;
            //var gduration = parseInt((target.time - active.start) * 1000);
            //var leader = (INFO.mock_custom_leader) ? INFO.mock_custom_leader : CONSTS.MOCK_DISPLAY_TIMER;
            var blen=666;
            var vleader = convertVideoTime(leader);
            if (timer_mode === true) {

                INFO.mock_debug && console.log("mock.1235:       TIMER BAR1   curr=", curr, " elapse=",elapse, " leader=",leader," end=",end, " a.start=",active.start);
                //if ((elapse >= -leader) && (elapse <= 50)) 
                if ((elapse >= (-leader * 1000)) && (curr <= end)) {
                    var x = active.points[0].x+"%";
                    var y = active.points[0].y+"%";

                    INFO.mock_debug && console.log("mock.1240:       TIMER BAR2   curr=", curr, " end=",end, " a.start=",active.start, " t_start=",INFO.mock_timing_start);
                    if (curr > INFO.mock_timing_start) {
                        if ((curr <= active.start)) {
                            //blen = parseInt((active.start - curr)/(vleader / 1000) * 80) + 5;
                            blen = parseInt((active.start - curr)/(vleader) * 80) + 5;
                            Annotate.draw_block("green", x, y, blen, 6);  // green visual cue bar

                            INFO.mock_debug && console.log("mock.1246:       TIMER BAR4   curr=", curr, " elapse=",elapse, " leader=",leader," end=",end, " a.start=",active.start, " blen=",blen, " x=",x, " y=",y);
                            if (TIMES.mock_show_target[idx0] === undefined) {
                                TIMES.mock_show_target[idx0] = t0;
                                console.log("mock.1036:       TIMER - SET SHOW TARGET TIME   idx0=",idx0, " curr=",curr, " a.start=",active.start, " end=",end," vleader=", vleader, " leader=", leader, " time=", t0, " blen=",blen, " t=", performance.now());
                            }
                        } else {
                            // at the end, show the answer
                            //
                            Annotate.draw_ellipse("#00cc0010", "#00ee0020", 1, active.points[1].x+"%", active.points[0].y+"%", ANSWER_SIZE, ANSWER_SIZE);   // #00f000052
                        }
                    }


                    // TIMER MODE: NEED TO SHOW THE CLICKS
                    var has_click = false;
                    if ((curr >= start) && (curr <= end)) {
                        var clicks = TIMES.mock_reacted;        // user clicks
                        var got_target = false;
                        var check = true;      // show only one
                        for(var i = 0; i < clicks.length; i++) {
                            var click = clicks[i];
                            if ((check === true) && (click.id === active.id) && (click.type === INFO.mock_type)) {
                                //console.log("mock.632:     SHOW ====> i=",i,"  t.click+",click.video_time, " curr=",curr, " a.start=",active.start, " a.end=",active.end, " clicks=", clicks);
                                var x = click.x;
                                var y = click.y;

                                got_target = true;
                                if (curr >= click.video_time) {
                                    //if (click.video_time >= (active.start - CONSTS.MOCK_ADVANCE_CLICK_SEC)) 
                                    if (click.video_time >= (active.start - leader)) {
                                        var duration0 = parseInt(parseFloat(click.time) - parseFloat(TIMES.mock_show_target[idx0]));       // high precision for reaction time

                                        // show expected target: for debug
                                        INFO.mock_debug && console.log("mock.533:    .  .  . TIMER CLICKED TARGET  i=",i, " dur0=",duration0, " c.time=",click_time, " c.vtime=",click.video_time, " idx0=",idx0, " x=", x, " y=",y, " end=",end, " a.start=",active.start);
                                        INFO.mock_debug && console.log("mock.533:                                  leader=",leader, " show.target=",TIMES.mock_show_target[idx0]);
                                        INFO.mock_debug && Annotate.draw_text("#ffffff80", "#00000030", FILM_TIME_SIZE, curr.toFixed(3) +" sec", TIMER_XOFFSET1, "+0.5%");   // elapse time

                                        Annotate.draw_ellipse(click.color, click.color, 1, x, y, 10, 10);   // #00f000052
                                        Annotate.draw_text("white", click.color, 16, duration0 +" msec", TIMER_XOFFSET2, "+0.5%");   // elapse time
                                        INFO.mock_active_click = click;
                                        has_click = true;
                                    } else {
                                        // clicked too early, show grey
                                        //console.log("mock.1071:     .  .  .  .  SHOW TOO EARLY CLICK x=", x, " y=",y, "  video_time=",click.video_time, " start=",active.start);
                                        Annotate.draw_ellipse("#33333352", "#333333a0", 1, x, y, 10, 10);
                                    }
                                    check = false;      // found one
                                } else {
                                    //console.log("mock.1147:     ORPHAN0  curr=",curr, " c.vtime=",click.video_time);
                                }
                            }
                        }
                    } 
                    
                    // film postion timer
                    //
                    if ((curr > INFO.mock_timing_start) && (has_click === false)) {
                        var vnow = ((curr - active.start) * 1000);
                        var now = convertRealTime(vnow).toFixed(0);     // account for playing speed
                        var color1 = (now >= 0) ? "#ff0000b0" : "#179b36b0";    // green or red
                        Annotate.draw_text(color1, "#ffffff40", 16, -now +" msec", TIMER_XOFFSET2, "+0.5%");   // elapse time
                    }

                }
            }


            // GUN MODE: display target mode indicator
            //
            if (gun_mode === true) {
                start = active.start - CONSTS.MOCK_DISPLAY_BEFORE_SEC;    // after everything
                end = active.end + CONSTS.MOCK_DISPLAY_AFTER_SEC;    // after everything

                //INFO.mock_debug && console.log("mock.1045:     SHOW TARGET3   gun_mode=",gun_mode, " curr=",curr, " start=",start, " end=",end, " clicks=",TIMES.mock_reacted);
                if ((curr >= start) && (curr <= end)) {
                    // show actual click location
                    //
                    var clicks = TIMES.mock_reacted;        // user clicks
                    var got_target = false;
                    INFO.mock_active_click = null;
                    for(var i = 0; i < clicks.length; i++) {
                        var click = clicks[i];
                        var click_time = parseInt(click.time);
                        if ((click.id === active.id) && (click.type === INFO.mock_type)) {
                            INFO.mock_debug && console.log("mock.632:  GUN SHOW CLICK =====> i=",i,"  t.click=",click.video_time, " curr=",curr, " a.start=",active.start, " a.end=",active.end, " click.time=", click_time);
                            var x = click.x;
                            var y = click.y;

                            got_target = true;
                            if (curr >= click.video_time) {
                                //if (click.video_time >= (active.start - CONSTS.MOCK_ADVANCE_CLICK_SEC)) 
                                if (click.video_time >= start) {
                                    //var duration = parseInt((click.video_time - active.start) * 1000);
                                    //duration = convertRealTime(duration);
                                    var duration0 = parseInt(parseFloat(click.time) - TIMES.mock_show_target[idx0]);       // high precision for reaction time

                                    // show expected target: for debug
                                    INFO.mock_debug && console.log("mock.1339:    .  .  . CLICKED GUN TARGET  i=",i, " dur0=",duration0, " c.time=",click_time, " c.vtime=",click.video_time, " idx0=",idx0, " x=", x, " y=",y, " end=",end, " a.start=",active.start);
                                    INFO.mock_debug && console.log("mock.1340:                                leader=",leader, " show.target=",TIMES.mock_show_target[idx0]);
                                    INFO.mock_debug && Annotate.draw_text("#ffffff80", "#00000030", 16, curr.toFixed(3) +" sec", TIMER_XOFFSET1, "+0.5%");   // elapse time

                                    Annotate.draw_ellipse(click.color, click.color, 1, x, y, 10, 10);   // #00f000052
                                    Annotate.draw_text("white", click.color, 16, duration0 +" msec", TIMER_XOFFSET2, "+0.5%");   // elapse time
                                    INFO.mock_active_click = click;
                                } else {
                                    // clicked too early, show grey
                                    //console.log("mock.1071:     .  .  .  .  SHOW TOO EARLY CLICK x=", x, " y=",y, "  video_time=",click.video_time, " start=",active.start);
                                    Annotate.draw_ellipse("#33333352", "#333333a0", 1, x, y, 10, 10);
                                }
                            } else if (curr >= (active.start - CONSTS.MOCK_ADVANCE_CLICK_SEC)) {
                                // after start but before click
                                //
                                if (click.video_time >= (active.start - CONSTS.MOCK_ADVANCE_CLICK_SEC)) {
                                    //console.log("mock.652:     NO CLICK YET  time=",click.video_time, " start=",active.start);
                                    Annotate.draw_text("red", null, 16, elapse +" msec", TIMER_XOFFSET2, "+0.5%");   // elapse time
                                } else {
                                    // ineligible: clicked too early, show grey
                                    //console.log("mock.658:     BAD CLICK TOO EARLY  time=",click.video_time, " start=",active.start);
                                    Annotate.draw_text("grey", "#33333352", 16, elapse +" msec", TIMER_XOFFSET2, "+0.5%");   // elapse time
                                }
                            } else {
                                //console.log("mock.1211:     ORPHAN1  curr=",curr, " a.start=",active.start," c.vtime=",click.video_time, " start=",start );
                            }
                        }
                    }

                    if ((elapse >= 0) && (got_target === false)) {
                        Annotate.draw_text("white", null, 16, elapse +" msec", TIMER_XOFFSET2, "+0.5%");   // elapse time
                    }
                } else {
                    if ((curr !== undefined) && (curr !== null)) {
                        Annotate.draw_text("#ffffff80", "#00000030", FILM_TIME_SIZE, curr.toFixed(3) +" sec", TIMER_XOFFSET1, "+0.5%");   // elapse time
                    } else {
                        //console.log("mock.1223:     ORPHAN2  curr=",curr, " start=",start," end=",end);
                    }
                    //INFO.mock_debug && console.log("mock.950:       FILM TIME curr=",curr, "  start=",start, " end=",end);
                }
            }


            // cheat mode: display targets to help with verify detect setting
            //
            if ((INFO.mock_debug) && (INFO.mock_type === "target")) {
                // show the expected target endpoints motion prorated by time
                //
                var [newx, newy] = interimTargetCoord(curr, active);
                var actual1 = active.points[1];
                var actual2 = active.points[2];
                var colort = (curr >= active.start) ? "#ffffff70" : "#66666620";
                Annotate.draw_ellipse("#00ff0052", "#00ff00a0", 2, actual1.x+"%", actual1.y+"%", 10, 10);
                Annotate.draw_ellipse("#ff000052", "#ff0000a0", 2, actual2.x+"%", actual2.y+"%", 10, 10);
                Annotate.draw_ellipse(colort, "#33333320", 2, newx+"%", newy+"%", 10, 10);
                //INFO.mock_debug && console.log("mock.801:       colort=",colort, " curr=",curr, " a.start=",active.start, " end=",end);
            }


            // DETECT-LIST-END: reached end of this detect, show next or stop
            //    - NOTE: need to special case skipping
            //
            //if ((curr > end) && (INFO.mock_running === true)) 
            if (curr > end) {
                var player = INFO.mock_player;
                var paused = player.paused;  // do we really need this?  takes awhile
                var click_hit = false;
                var mock_reacted = null;

                // NOTE: only do auto roll over when playing
                //
                if (paused === false) {
                    var click = TIMES.mock_reacted[idx0];
                    if (click !== undefined) {
                        mock_reacted = parseInt(click.time)
                        click_hit = click.hit;

                        var run = {};
                        run.mock_reacted = mock_reacted;
                        run.hit = click_hit;
                        run.mock_show_target = parseInt(TIMES.mock_show_target[idx0]);
                        run.click = click;      // keep detail for playback later
                        RUNS.push(run);     // result collected in displayRunResults();
                        console.log("mock.1350:     .  .  ,  ,  idx0=",idx0,"  show=",run.mock_show_target, " react=",run.mock_reacted,"    ADDING ==> run=",run);
                    }

                //INFO.mock_debug && console.log("mock.1324:       DETECT END   idx0=",idx0, " curr=",curr, " start=",start, " end=",end, "paused",paused, " click=",click);

                    // process click result
                    //
                    var time = (mock_reacted) ? Math.floor(run.mock_reacted - run.mock_show_target) : null;
                    TIMES.mock_perf_react.push(time);
                    if(click_hit === true) {
                        //TIMES.mock_end_target[idx0] = t0;
                        TIMES.mock_perf_good.push(time);

                        // process star count to give user feedback
                        //      - store in RUNS, set the stars
                        processPerRepStars(run, "mock");    // calc drill_stars
                        setStarCnt(INFO.drill_stars);
                        console.log("mock.1143:     .  .  .  .  GOOD MOCK Perf: idx0=",idx0, " time=", time, " show=",run.mock_show_target, " react=",run.mock_reacted);
                    } else {
                        TIMES.mock_perf_bad.push(time);
                        setStarCnt(0);      // do not display stars if it's a miss!
                        //console.log("mock.1183:     .  .  .  .  BAD MOCK Perf: idx0=",idx0, " time=", time);
                    }

                    var done = false;
                    INFO.mock_rounds = INFO.mock_rounds + 1;
                    if (INFO.mock_rounds < CONSTS.MOCK_MAX_CNT) {
                        Annotate.draw_block("#ffffff44", "50%", "50%", "100%", "100%");     // display white speparator

                        var idx = idx0 + 1;
                        //var detect = INFO.mock_execute[idx];
                        var detects = startNextMockTarget();
                        console.log("mock.615:    ========>> SELECT NEXT TARGET   idx=",idx," curr=",curr, " end=",end);  //, " detects=",detects,"  ", INFO.mock_execute);

                        if (detects === null) {
                            done = true;

                        } else {

                            //var vid_start = detects[INFO.mock_type].start;
                            //startDetectSession(vid_start);
                            //setDetectStart(vid_start);
                            var vid_start = detects.start - (CONSTS.MOCK_DISPLAY_PREVIEW/1000);
                            INFO.mock_video_seek = (vid_start > 0) ? vid_start : 0;
                            setDetectRefresh(DetectRefresh+1);
                            player.setTime(INFO.mock_video_seek);       // can we do it here?

                            console.log("mock.1475:       .  .  .  .  B4 start NEXT detect  seek=",INFO.mock_video_seek, " detects.start=",detects.start);  //  , " detects=",detects);
                        }
                    } 
                    
                    // quit if did all the rounds or ran out of detect
                    //
                    if (done === true) {
                        // finished all round, wrap up
                        //
                        player.stop();
                        if(!EndPauseTimer) {
                            var timer = setTimeout(()=> {
                                console.log("mock.1321:    -------- STOPPING MOCK");
                                endMock("save");        // SHOW THE RESULT
                            },  CONSTS.MOCK_DISPLAY_END);
                            setEndPauseTimer(timer);
                        }
                    }

                } else {
                    // ERROR: no active detect running (should not be)
                    if (curr) {
                        Annotate.draw_text("#ffffff80", "#00000030", FILM_TIME_SIZE, curr.toFixed(3) +" sec", TIMER_XOFFSET1, "+0.5%");   // elapse time
                    }
                }

            }   // if (curr > end)
        }   // if (active)


        var show_calibration_marks = false;
        if (show_calibration_marks === true) {
            var color = "red";
            var size = 6;
            Annotate.draw_block(color, "0%", "0%", size, size); 
            Annotate.draw_block(color, "0%", "calc(100% - 3px)", size, size);
            Annotate.draw_block(color, "calc(50% - 3px)", "calc(50% - 3px)", size, size);
            Annotate.draw_block(color, "calc(100% - 3px)", "0%", size, size); 
            Annotate.draw_block(color, "calc(100% - 3px)", "calc(100% - 3px)", size, size);
        }
    }



    // MAIN: Show annotation over the video
    //     - called by periodic timer
    //     - and when something changes
    //     - using dual buffer to reduce screen flicker
    //
    async function displayAnnotation() {

        // once started, do not stop
        //
        //if(INFO.mock_running === true) {
            var timer = setTimeout(()=> {
                requestAnimationFrame(displayAnnotation);
            },  CONSTS.MOCK_DISPLAY_REFRESH);
            setAnnotationTimer(timer);
        //}

        var annotate = INFO.annotate;
        if ((annotate === null) || (INFO.mock_player === null)) {
            //console.log("annotate.450:  !!!!!! ERROR: Unable to ANNOTATE  annotate=",INFO.annotate);    //, " player=",INFO.mock_player);
            return;     // not ready yet
        }

        var ctx0 = annotate.ctx0;
        var ctx1 = annotate.ctx1;
        var canvas0 = annotate.canvas0
        var canvas1 = annotate.canvas1
        //INFO.mock_debug && console.log("mock.1009:     .  .  .  .    RUN display    type=",INFO.mock_type, " ctx0=",ctx0.canvas,"  ctx1=",ctx1.canvas, " canvas1=",canvas1);

        var curr = await INFO.mock_player.getTime();  // IMPORTANT: MUST Read the time BEFORE rendering for smooth graphics
        ctx1.clearRect(0, 0, canvas0.width, canvas0.height);    // need this!

        // NOTE: **** DISPLAY ROUTINE ARE TIME SENSITIVE! NO BLCOK ONLY! ****
        //
        if (INFO.mock_edit_mode === true) {
            displayEditMode(curr);
        } else {
            switch (INFO.mock_type) {
                case "comment":
                    await displayTarget(curr);        // MUST have await!
                    break;
                case "target":
                case "path":
                case "position":
                case "passing":
                    await displayTarget(curr);        // MUST have await!
                    break;
            }
        }
        ctx0.clearRect(0, 0, canvas0.width, canvas0.height);        // need this!
        ctx0.drawImage(canvas1, 0, 0);   //console.log("annotate.521:    DRAW IMAGE");

    }




    //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    //   UTIL: SUPPORT ROUTINES
    //

    // UTIL - DISPLAY ANNOTATION
    // convert from video time to real elapsed time
    //     - everything based off of video playing time
    //     - need to scale click time based on playing speed
    //
    function convertRealTime(time) {
        var play = (INFO.mock_playing_speed) ? INFO.mock_playing_speed : 1;
        var actual = time / play;

        return parseFloat(actual);
    }


    // convert from real time to video elapse time (delta)
    //
    function convertVideoTime(time) {
        var play = (INFO.mock_playing_speed) ? INFO.mock_playing_speed : 1;
        //var actual = time / play;
        var actual = time * play;

        return parseFloat(actual);
    }



    // fetch next detect object
    //     - tot_mock_detects[]:  detects from ALL footage from db
    //     - all_mock_detects[]:  all modes of detects belong to active footage
    //     - mock_detects[]:  active mock_mode of detects
    //     - mock_execute[]:  runtime list of detects, whqt player sees
    //
    function nextRandomDetect(index) {
        var detects = INFO.mock_detects[INFO.mock_type];
        var detect = {};

        var looking = true;
        var back_idx = null;
        while (looking) {
            var index = Math.floor((Math.random(Date.now() % 100) * detects.length));
            //var detect = INFO.mock_detects[index];
            detect = detects[index];

            var dup = false;
            for (var i = 0; i < INFO.mock_execute.length; i++) {
                var execute = INFO.mock_execute[i];
                if (execute.start === detect.start) {
                    dup = true;
                    break;
                }
            }

            if(dup === false) {
                back_idx = index;
                looking = false;
            }
        }
        var exec = makeExecute(detect, index, back_idx);
        return exec;
    }


    function nextSequentialDetect(index, last_idx) {
        var detects = INFO.mock_detects[INFO.mock_type];
        var detect = {};
        var idx; 

        if (last_idx) {
            idx = last_idx + 1;
            if (idx >= detects.length) {
                return null;      // no more, done
            }
        } else {
            idx = 0;
        }

        detect = detects[idx];
        var exec = makeExecute(detect, index, idx);
        return exec;
    }



    function makeExecute(detect, index, back_idx) {
        if (!detect) return null;

        //var id = idx.toString() + Date.now().toString();
        var exec = {}
        exec = {...detect}
        exec.start = parseFloat(exec.start);
        exec.end = parseFloat(exec.end);
        //exec.leader = INFO.mock_custom_leader;    // for timer mode: in "real time sec" before kick
        exec.leader = (INFO.drill_param1) ? INFO.drill_param1.leader : 1000;    // for timer mode: in "real time sec" before kick
        exec.id = index.toString() + Date.now().toString();
        exec.back_idx = back_idx;
        console.log("mock.549:       .  .  .  .   NEXT DETECT   e.start=",exec.start, " e.end=",exec.end, "  leader=", exec.leader);
        return exec;
    }


    // create a array of Detect objects
    //
    function createDetectList() {
        var detects = INFO.mock_detects[INFO.mock_type];
        if ((detects === undefined) || (detects.length === 0)) {
            console.log("mock.648:         !!!!!!!!  CreateDetect: STILL NO mock_detects  mock_type=",INFO.mock_type,"  INFO.mock_detects=",INFO.mock_detects);
            return null;
        }

        INFO.mock_execute = [];
        var max = detects.length;
        var last_idx = null;
        var loop = (max > 8) ? 8 : max;         // KLUDGE: HARD CODING LOOP!
        for (var i = 0; i < loop; i++) {
            var exec = null;
            var random = false;
            if (random === true) {
                exec = nextRandomDetect(i, false);
            } else {
                //exec = nextSequentialDetect(i, last_idx);
                exec = makeExecute(detects[i], i, i);
                last_idx = exec.back_idx;
            }

            if (exec) {
                INFO.mock_execute.push(exec);
            } else {
                break;  // no more;
            }
        }

        INFO.mock_target_idx = 0;
        console.log("mock.564:    ===== CREATE DETECT LIST len=",INFO.mock_execute.length," ", INFO.mock_execute);
        return INFO.mock_execute.length;
    }


    // pause then play detect
    //    - give player time to find the ball
    //    - start slow at .25X
    //    - then play at custom dril speed
    //
    // NOTE: VIDEO PLAYER MUST BE READY BEFORE CALLING THIS
    //
    async function startDetectSession(start0) {
        var player = INFO.mock_player;

        if (!player) {
            console.log("mock.1740:    !!!!!!! START_DETECT_SESSION FAIL - NO VIDEO PLAYER!!!   start0=",start0);
            return;
        }

        var idx0 = parseInt(INFO.mock_target_idx);
        var active = INFO.mock_execute[idx0];  // the detect template
        console.log("mock.1798:     ..... TRY TO START DETECT_SESSION   start0=",start0, " running=", INFO.mock_session_running, " active=",active," time=",parseInt(performance.now()));

        var mode = findMockRunMode(INFO.mock_type);
        var clean = player.paused || INFO.mock_edit_mode;
        var [start, end, leader] = calcDetectEndpoints(start0, 0, mode, clean);     // conver real time to video time
        //var [start, end, leader] = calcDetectEndpoints(start0, 0, mode, INFO.mock_edit_mode);

        if ((player !== null) && (INFO.mock_session_running === false)) {
            INFO.mock_session_running = true;
            INFO.mock_timing_start = 999999;
            console.log("mock.1139:     START_DETECT_SESSION   start0=",start0, " start=", start, " mode=",mode, " clean=",clean, " player.state=",player.getPlayerState(), " time=",parseInt(performance.now()));  //player=", player);

            player.pause();
            player.setSpeed(0.25);       // slow start for orientation
            player.setTime(start);
            player.start();       // slow start for orientation

            // play slow ramp
            //
            var timer1 = setTimeout(async ()=> {
                if (player !== null) {
                    var curr = await player.getTime();
                    player.setSpeed(0.25);       // slow start for orientation
                    //if ((curr < INFO.mock_video_seek)) {      // THIS IS *BAD*, removed first timer bar
                    if ((curr == 0)) {
                        player.setTime(INFO.mock_video_seek);   // KLUDGE: IN CASE SEEK DIDN'T HAPPEN ABOVE!!
                    }
                    console.log("mock.1826:    ++++++++++ START SLOW MO    curr=",curr,"  mock_timing_start=",INFO.mock_timing_start.toFixed(3), " time=",parseInt(performance.now()));  //player=", player);
                    player.start();
                }
            },  CONSTS.MOCK_START_DELAY+CONSTS.MOCK_PRESTART_DELAY);
            setPauseStartTimer(timer1);


            // back to normal speed
            //
            var timer2 = setTimeout(async ()=> {
                if (player !== null) {
                    var curr = await player.getTime();
                    INFO.mock_timing_start = curr + CONSTS.MOCK_START_MEASURE_DELAY_SEC;      // give it 100 msec to stablize
                    player.setSpeed(INFO.mock_playing_speed); 
                    console.log("mock.1838:    ++++++++++ START FOR REAL    curr=",curr,"  mock_timing_start=",INFO.mock_timing_start.toFixed(3), " time=",parseInt(performance.now()));  //player=", player);
                    player.start();
                }
            },  (CONSTS.MOCK_PRESTART_DELAY+CONSTS.MOCK_START_DELAY));
            setRampStartTimer(timer2);
        } else {
            console.log("mock.1574:    !!!!!!! ERROR: PLAYER NOT READY!  start=",start, " mode=",mode, " clean=",clean);
        }
    }



    // RUN TIME: initialize the detect run and play first video
    //
    function setupDetectVideo() {
        var player = INFO.mock_player;
        var idx = INFO.mock_target_idx;
        var detect = INFO.mock_execute[idx];

        if ((detect !== undefined) && (player !== null)) {
            //var start = (detect.start - (CONSTS.MOCK_DISPLAY_PREVIEW/1000));
            //startDetectSession(detect.start);
            //setDetectStart(detect.start);
            INFO.mock_video_seek = detect.start;
            setDetectRefresh(DetectRefresh+1);

            console.log("mock.719:     START DETECT VIDEO    d.start=",detect.start);
        }
        return detect;
    }


    // initialize the detect run and play first video
    //
    function startDetectRun() {
        var cnt = createDetectList();
        if(cnt > 0) {
            setupDetectVideo();
        }
        console.log("mock.731:     +++++++++++++++++++++ START DETECT RUN  mock_execute=", INFO.mock_execute.length, "  cnt=",cnt);
    }


    // infer target position based on time 
    //
    function interimTargetCoord(t0, active) {
        var p1 = active.points[1];
        var p2 = active.points[2];

        if (p2) {
            var t1 = p1.time;
            var t2 = p2.time;
            var tpct = (t0 - t1) / (t2 - t1);
            var dx = p2.x.slice(0,-1) - p1.x.slice(0,-1)
            var dy = p2.y.slice(0,-1) - p1.y.slice(0,-1)
            var nx = (tpct * dx) + parseFloat(p1.x.slice(0,-1));
            var ny = (tpct * dy) + parseFloat(p1.y.slice(0,-1));
            //console.log("mock.1161:   t0=",t0, " t1=",t1, "t2=",t2, " tpct=",tpct.toFixed(3), " dx=",dx.toFixed(0), " dy=",dy.toFixed(0), " p1.x=",p1.x, " p1.y=",p1.y, " p2.x=",p2.x," p2.y=",p2.y," nx=",parseInt(nx), " ny=",parseInt(ny));
            return [nx, ny];

        } else {
            //console.log("mock.1530:     .  .  .  .  SINGLE COORD   p1.x=",p1.x, " p1.y=",p1.y);
            return [p1.x, p1.y];    // if single snapshot, no interpolation
        }
    }


    // convert dist (% of screen) into a traffic light score
    //     - below 8% is a hit
    //     - above 25% is a miss
    //
    function scoreDistance(dist) {
        var score = 0, color = null;
        const best = 4;
        const worst = 16;

        if(dist < best) {
            score = 100;
            color = "#00bb0050";     // green
        } else if (dist > worst) {
            score = 0;
            color = "#ff000050";      // red
        } else {
            score = parseInt(((worst - dist) / (worst - best)) * 100);        // prorate
            if (score < 30) {
                color = "#ffa07a50";        // light salmon
            } else if (score < 50) {
                color = "#ffa50050";       // orange
            } else {
                color = "#40e0d050";        // turquoise
            }
        }
        console.log("mock.1201:         .  .  .  .  RESULT:  dist=",parseInt(dist), " score=",score, " color=",color);
        return [score, color];
    }



    // set up canvas annotation object - canvas buffer to draw on then copy to primary
    //
    const initAnnotateContext = (from) => {
        var annotate = INFO.annotate;
        //var canvas0 = document.querySelector('#mock_input');
        var canvas0 = document.querySelector('#mock_buffer0');
        if ((canvas0 === null) || (canvas0 === undefined)) {
            console.log("annotate.734:  !!!!!! ERROR: No #mock_buffer0 Canvas!");
            return;     // not ready yet
        }

        var ctx0 = canvas0.getContext("2d");
        if ((annotate !== null) && (annotate.URL === props.SelectedItem.url)) {
            // still has to restart the timer
            //
            console.log("annotate.739:   !!!!!!!! INFO.annotate ALREADY SET, NO INIT   SAME url=",INFO.annotate.url);
            INFO.prime_canvas = annotate.canvas0;
            INFO.prime_context = annotate.ctx0;
            INFO.out_canvas = annotate.canvas1;
            INFO.out_context = annotate.ctx1;

        } else {
            INFO.prime_canvas = canvas0;
            INFO.prime_context = ctx0;

            // hidden secondary display buffer
            //
            //var canvas2 = document.createElement("canvas");
            var canvas1 = document.querySelector('#mock_buffer1');
            var ctx1 = canvas1.getContext("2d");
            canvas1.width = canvas0.width;
            canvas1.height = canvas0.height;
            INFO.out_canvas = canvas1;
            INFO.out_context = ctx1;

            //annotate = new AnnotationClass(canvas0, canvas0.width, canvas0.height);     // TESTING ONLY: WRITE DIRECT TO PRIMARY
            annotate = new AnnotationClass(canvas1, canvas0.width, canvas0.height);
            annotate.url = props.SelectedItem.url;
            annotate.canvas0 = canvas0;
            INFO.annotate = annotate;      // draw to secondary buffer first
            //console.log("mock.1233:   ++++++++++++++++ MOCK CREATED _NEW_   INFO.annotate  ctx0=",annotate.ctx0.canvas, " url=",INFO.annotate.url);
        }

        INFO.mock_scale_x = annotate.scalex;
        INFO.mock_scale_y = annotate.scaley;
        //console.log("mock.1216:             ***** MOCK ANNOTATE0 INIT   scale_x=",INFO.mock_scale_x,"  scale_y=",INFO.mock_scale_y);

        if (AnnotationTimer !== null) {
            clearTimeout(AnnotationTimer);      // get rid of old one
        }
        if (PauseStartTimer !== null) {
            clearTimeout(PauseStartTimer);      // get rid of old one
        }
        if (RampStartTimer !== null) {
            clearTimeout(RampStartTimer);      // get rid of old one
        }
        displayAnnotation();        // start new annotation
        console.log("mock.1238:             ***** MOCK ANNOTATE1 INIT START.....from=",from);   //, " ctx1",INFO.annotate.ctx1.canvas,"   annotate=",INFO.annotate.url); //, "  ctx2=", ctx2);
    }


    const Stars = (props) => {
        const [ STARS, setSTARS ] = useState([]);
        useEffect(() => {
            var stars = []
            for (var i = 0; i < props.StarCnt; i++) {
                stars.push(i);        // XXCD: KLUDGE: STUPID WAY TO DO THIS....NEED TO FIX
            }
            //console.log('getSTAR.670:  -------> DRAW STARS    XXXXXXXX stars=',props.StarCnt, " stars=",stars);
            setSTARS(stars);
        }, [props.StarCnt]);

        useEffect(() => {
        }, [STARS]);

        return (
            <React.Fragment>
                {STARS.map(
                    (item, indx) => {
                        return( <img key={"star"+indx} src={require("../assets/images/star75.png")} className={classes.star_icon} /> )
                    }
                )}
            </React.Fragment>
        )
    }



    //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    //   TOUCH RUNTIME HANDLER ROUTINES
    //


    // CLICK Edit Mode
    //    - collect clicks, end with "Q"
    //    - first click sets the start time, display timer
    //    - second click mark target with elapse time
    //    - third click mark target with elapse time
    async function processEditModeClick(click) {
        var target={}, duration=0, x=0, y=0;
        var Annotate = INFO.annotate;
        var xpct = (click.xpos / Annotate.ctx_width * 100).toFixed(2);
        var ypct = (click.ypos / Annotate.ctx_height * 100).toFixed(2);

        if(INFO.mock_start_time === null) {
            INFO.mock_start_time = click.time;
            INFO.mock_show_timer = true;
        } else {
            duration = click.time - INFO.mock_start_time;
        }

        //target.time = performance.now();        // no need, wall clock time
        target.video_time = click.time;
        target.duration = duration.toFixed(3);
        target.xpos = click.xpos;
        target.ypos = click.ypos;
        target.x = xpct;
        target.y = ypct;
        target.type = "edit";
        TIMES.mock_reacted.push(target);
        console.log("mock.2085:      EDIT MODE CLICK   TargetTimes=",TIMES.mock_reacted, "  showTimer=",INFO.mock_show_timer, " xpct=",xpct, " ypct=",ypct);
    }


    // CLICK Target Runtime 
    //    - first click sets the start time, display timer
    //    - second click mark target with elapse time
    //    - third click mark target with elapse time
    async function processTargetClick(click, count) {
        var target={}, duration=0, x=0, y=0;
        if (!INFO.annotate) { return };     // not ready

        var active = INFO.mock_execute[INFO.mock_target_idx];      // template
        var id = (active === undefined) ? null : active.id;
        var paused = INFO.mock_player.paused;

        // check to see if we have reached the target number of clicks
        //
        var clicks = TIMES.mock_reacted;
        var cnt = 0;
        for(var i = 0; i < clicks.length; i++) {
            var click0 = clicks[i];
            if (click0.id === id) {
                cnt = cnt + 1;
            }
        }
        if ((count !== null) && (cnt >= count)) {
            console.log("mock.779:   !!!!!!  INVALID, EXCEEDED COUNT!!   count=",count, " clicks=",clicks);
            return;
        }


        // process click detection
        //    - convert to % to account for diff display size
        //    - check if click is at right coord and right time
        //
        var Annotate = INFO.annotate;
        var xpct = (click.xpos / Annotate.ctx_width * 100).toFixed(2);
        var ypct = (click.ypos / Annotate.ctx_height * 100).toFixed(2);

        var curr = await INFO.mock_player.getTime();  // can not use React var here!
        //console.log("mock.2066:  ******  CLICK  time=",curr, " x%=", xpct, " y%=",ypct,  " c_w=",Annotate.ctx_width, " click=",click);   // ," ctx0=",Annotate.ctx0.canvas,);
        target.hit = false;
        if ((active !== null) && (active !== undefined)) {
            //if ((curr > active.start) && (curr < active.end)) 
            var mode = findMockRunMode(INFO.mock_type);
            var [start, end, leader] = calcDetectEndpoints(active.start, active.end, mode, paused);
            var valid = false;
            switch (mode) {
                case "gun":
                    if ((curr > start) && (curr < end)) {
                        valid = true;
                    }
                    break;
                case "timer":
                    if ((curr > (start - leader)) && (curr < active.start)) {
                        valid = true;
                    }
                    break;
            }

            //if ((curr > start) && (curr < end)) {
            if (valid === true) {
                var target0 = active.points[1];
                var expx = target0.x.slice(0,-1);
                var expy = target0.y.slice(0,-1);
                var [newx, newy] = interimTargetCoord(curr, active);
                var dist = calcPixelDistance(newx, xpct, newy, ypct);
                var [score, color] = scoreDistance(dist);

                target.score = score;
                target.color = color;
                target.valid = true;
                if (score > 0) {
                    target.hit = true;
                    console.log("mock.2100:  ******  CLICK GOT HIT   valid=", valid, " score=",score," dist=", dist, " hit=",target.hit,"  EXP: x%=",expx, " y%=", expy, " ACT: x%=", xpct, " y%=",ypct);
                } else {
                    console.log("mock.2102:  ******  CLICK GOT MISS   valid=", valid, " score=",score," dist=", dist, " hit=",target.hit,"  EXP: x%=",expx, " y%=", expy, " ACT: x%=", xpct, " y%=",ypct);
                }

                //console.log("mock.600:  ******              newx=", newx, "  newy=",newy, " curr=", curr);
                //INFO.mock_stop_time = curr;     // need to adjust for playing speed
                INFO.mock_press_cnt = INFO.mock_press_cnt + 1;
            } else {
                target.valid = false;
                target.hit = false;
                target.score = 0;
                target.color = '#66666620';
                console.log("mock.2113:  ******  CLICK TOO LATE   valid=", valid, " score=",score," dist=", dist, " hit=",target.hit,"  EXP: x%=",expx, " y%=", expy, " ACT: x%=", xpct, " y%=",ypct);
            }

            duration = click.time - active.start;
        }

        //target.time = click.time;
        target.time = parseInt(performance.now());        // wall clock time
        target.video_time = click.time;
        target.duration = duration.toFixed(3);
        target.xpos = click.xpos;
        target.ypos = click.ypos;
        target.x = xpct+"%";
        target.y = ypct+"%";
        target.id = id;   // tie to detect start time
        target.type = INFO.mock_type;   // tie to detect start time
        TIMES.mock_reacted.push(target);
        console.log("mock.427:   CLICK  time=",target.time, " t=",performance.now());
    }





    //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    //   EVENT HANDLER ENTRIES
    //

    // Handle Touch START Events
    //      - Analysis Mode: Single step to identify start of visual stimulus and calc reaction time
    //      - Train Mode: 
    //               * Mark start of visual stimulus, direction of ball travel
    //               * Mark start of visual stimulus, best passing option 
    //      - Target Mode: Player touches target, system report reaction time and accuracy
    //
    // NOTE: CAN NOT ACCESS REACT VARS!!!
    //
    // ref: https://developer.mozilla.org/en-US/docs/Web/API/Touch_events
    // code: https://jsfiddle.net/Darbicus/z3Xdx/10/
    // coord_ref:  https://javascript.info/coordinates
    // position_ref: https://css-tricks.com/absolute-relative-fixed-positioining-how-do-they-differ/
    const handleTouchStart = async event => {
        var curr = null, x = null, y = null;
        var touchpad = document.getElementById('drill_output');
        if (!touchpad) { return };

        var touch = (event.targetTouches === undefined) ? event : event.targetTouches[0];
        event.preventDefault();     // block new ones to prevent overflow

        function findOffset(element) {
            var top = 0, left = 0, id = null;
            do {
                top += element.offsetTop  || 0;
                left += element.offsetLeft || 0;
                id = element.id;
                //console.log("mock_touch.377:                 top=",top, " left=",left, "  id=",id, " ele=", element);
                element = element.offsetParent;
            } while(element);

            return {
                top: top,
                left: left
            };
        };

        var cumOffset = findOffset(touchpad);
        var click = {};

        if(INFO.mock_player !== null) {
            curr = await INFO.mock_player.getTime();  // can not use React var here!
            curr = (curr) ? curr.toFixed(3) : -1;
        }
        click.xpos = (touch.clientX - cumOffset.left).toFixed(0);
        click.ypos = (touch.clientY - cumOffset.top).toFixed(0);
        //console.log("mock_touch.888:  TOUCH DETECTED0!  xpos=",click.xpos, " ypos=",click.ypos, " vwidth=",INFO.video_width, " vheight=",INFO.video_height);
        click.x = (click.xpos / INFO.video_width * 100).toFixed(3)+"%";     // in %
        click.y = (click.ypos / INFO.video_height * 100).toFixed(3)+"%";    // in %
        click.time = curr;
        console.log("mock_touch.316:  TOUCH DETECTED1!  time=",curr,"  x=", click.x, " y=", click.y, "  mode=",INFO.mock_type, " url=",(INFO.annotate) ? INFO.annotate.url : null, " t=",parseInt(performance.now()));

        if (INFO.mock_edit_mode === true) {
            // edit mode
            //
            processEditModeClick(click);
        } else {
            // runtime
            //
            switch (INFO.mock_type) {
                case "comment":
                case "passing":
                    // ActiveObj
                    processTargetClick(click, null);
                    break;
                case "target":
                case "position":
                case "path":
                    processTargetClick(click, 1);       // expect 1 click
                    break;
            }
        }


        if (INFO.mock_running == false) {
            //return;
        }

    }


    // a finger has been lifted up, either calc reaction time or too early
    //
    const handleTouchEnd = event => {
        var touches = event.changedTouches;
        var react_time;

        event.preventDefault();     // block new ones to prevent overflow
        if ((INFO.mock_running == false) || (Replay === true)) {
            return;
        }

        var t0 = performance.now();
        //console.log("mock.346:  Finger LIFTED  cnt=", touches.length, "  targets=",INFO.mock_target.length);
    }


    const handleDismissTutorial = () => {
        console.log("menu.2242: ----->  REACHED HANDLE_DISMISS_TUTORIAL");
        setShowTutorial(false);
    }


    const handleMockMetadataReady = () => {
        //createDetectList();
        //INFO.mock_target_idx = 0;
        //startDetectRun();

        //resetMockState("db_metadata_jeady.1252");     // need this?
    }


    // Player Ready
    //     - On first one, we do not start() because it mess up perf timing
    //     - After that, we can start
    //
    const handleVideoPlayerReady = async (player) => {

        INFO.mock_player = player;  // for use in callbacks
        var duration = await player.getDuration();

        adjustMockDisplay("player_ready.2370");      // resize it

        setVideoPlayer(player);
        console.log("mock.470  ++++++++++++++++++++ <Mock> GOT VideoFrame PLAYER READY!   rounds=",INFO.mock_rounds, "   mock_type=",INFO.mock_type, " start_time=",INFO.mock_start_time," vid_start=",INFO.video_start, " duration=",duration," playerState=", player.getPlayerState(), " url=",player.getPlayerURL());

        setDetectRefresh(DetectRefresh+1);
        if (player.paused || (INFO.mock_rounds > 0)) {
            player.pause();
            player.mute();
            player.setSpeed(0.25);     // 
            player.setTime(INFO.mock_video_seek);     // 

            player.start();     // First round we start() after player click start (in startMock())
            console.log("mock.2298              _ _ _ _ _   START FROM READY");
        }
    }


    // track youtube player state change
    //
    const handleVideoStateChange = async (event) => {
        //var player = event.target;
        //var state = player.getPlayerState();
        var player = INFO.mock_player;

        //console.log("mock.486:              ~~~~~~~~~~ Video State CHANGED   event=",event, " seek=",INFO.mock_video_seek,  " running=", INFO.mock_session_running, " time=",parseInt(performance.now()));  //,"  player=", player);
        if (!player) {
            console.log("mock.3212:              STATE CHG - NO PLAYER!");
            return;
        }

        //" state=",player.getPlayerState(),
        switch (event) {
            case "ready":
                var curr = await player.getTime();
                var duration = await player.getDuration();
                console.log("mock.2298:                   _ _ _ _ _ VIDEO READY!   curr=",curr, " seek=",INFO.mock_video_seek, " running=", INFO.mock_session_running, " duration=",duration, " time=",parseInt(performance.now()));  //,"  player=", player);
                break;
            case "seeked":
                var curr = await player.getTime();
                console.log("mock.2300:                   _ _ _ _ _ VIDEO STATE ",event,"   curr=",curr, " seek=",INFO.mock_video_seek, " running=", INFO.mock_session_running, " time=",parseInt(performance.now()));  //,"  player=", player);
                //setDetectRefresh(DetectRefresh+1);
                if ((INFO.mock_video_seek) && (!INFO.mock_session_running)) {
                    startDetectSession(INFO.mock_video_seek);
                }
                break;
            case "play":
            case "playing":
            case "progress":
                break;
        }
    }


    const handleMockClear = (event) => {
        console.log("mock.1184:       !!!!!!!!!! HANDLE MOCK CLEAR   exec=",INFO.mock_execute);
        INFO.mock_show_timer = false;       // reset time in analysis mode
        INFO.mock_start_time = null;
        TIMES.mock_reacted = [];

        INFO.mock_target_idx = 0;
        setupDetectVideo();
        //createDetectList();
    }


    // smart video skipping
    //     - if in RUN mode, skip to next execute
    //     - if in EDIT mode, skip to next detect if there is one in the direction
    //             * <alt><ctrl>:  goes to start or end detect
    //             * <alt>:   skip 50 secs, does not stop at detect
    //             * <ctrl>:   skip 5 sec, stop at detect
    //             * <_none_>:   skip 0.5 sec, stop at detect
    //             * <shift>:   skip 0.05 sec
    //
    const findNextDetect = async (steps, ctrl, alt) => {
        var curr = await INFO.mock_player.getTime();  // can not use React var here!
        var delta = 99999, delta0, index = null;
        var forward = (steps > 0) ? true : false;
        var oidx = INFO.mock_target_idx;
        var execs = INFO.mock_execute;
        //var detects = INFO.mock_detects[INFO.mock_type];
        var edit = INFO.mock_edit_mode;
        execs = (edit === true) ?  INFO.mock_detects[INFO.mock_type] : INFO.mock_execute;

        // search for closest in the given direction
        //    - if curr already in a detect, skip to next one
        //
        if (alt == true) {
            if (ctrl == true) {
                index = (forward === true) ? (execs.length - 1) : 0;    // very end or the start
            } else {
                index = null;       // <alt>+<ctrl> does not trigger detect skips
            }

        } else if (edit === true) {
            // search in timeline and find the closest
            //

            for (var i = 0; i < (execs.length - 1); i++) {
                var exec0 = execs[i];
                var exec1 = execs[i + 1];
                var start0 = parseFloat(exec0.start) - (CONSTS.MOCK_DISPLAY_PREVIEW/1000);
                var start1 = parseFloat(exec1.start) - (CONSTS.MOCK_DISPLAY_PREVIEW/1000);
                var end0 = parseFloat(exec0.end)
                var end1 = parseFloat(exec1.end)

                //console.log("mock.1649:         . . . . EDIT STEP  i=",i," fwd=",forward,"   index=", index, " curr=",curr, " start0=", start0, " end0=",end0, " start1=",start1, " end1=",end1);
                if ((forward === true) && (curr >= start0) && (curr < start1)) {
                    index = i + 1;
                    //console.log("     fwd 1     index=", index)
                }
                if ((forward === false) && (curr <= end1) && (curr > end0)) {
                    index = i;
                    console.log("     back 1     index=", index)
                }
            }
            var start00 = parseFloat(execs[0].start) - (CONSTS.MOCK_DISPLAY_PREVIEW/1000);
            var end00 = parseFloat(execs[0].end);
            var start11 = parseFloat(execs[execs.length - 1].start) - (CONSTS.MOCK_DISPLAY_PREVIEW/1000);
            var end11 = parseFloat(execs[execs.length - 1].end);

            if (forward === true) {
                //if (curr >= end11) {
                if (curr >= start11) {
                    index = null;
                    //console.log("     fwd past end     index=", index)
                }
                /* use <alt>+<ctrl>
                if (curr < start00) {
                    index = 0;
                    //console.log("     fwd to first     index=", index)
                }
                */
            }

            if (forward === false) {
                //if (curr <= start00) {
                if (curr <= end00) {
                    index = null;
                    //console.log("     back past start     index=", index)
                }
                /* use <alt>+<ctrl>
                if (curr > end11) {
                    index = execs.length - 1;
                    console.log("     back to end     index=", index)
                }
                */
            }
        } else {
            // just sequential step in run mode
            var idx1 = INFO.mock_target_idx;
            index = (forward === true) ? (idx1 + 1) : (idx1 - 1);
            index = (index < 0) ? 0 : index;
            index = (index >= execs.length) ? (execs.length - 1) : index;
        }


        if (index !== null) {
            if (!INFO.mock_edit_mode) {
                INFO.mock_target_idx = index;
            }

            var exec1 = execs[index];
            var start = exec1.start;        // - (CONSTS.MOCK_DISPLAY_PREVIEW/1000);
            //startDetectSession(start);
            //setDetectStart(start);
            INFO.mock_video_seek = start;
            setDetectRefresh(DetectRefresh+1);

            console.log("mock.1645:       VIDEO BIG STEP:  oidx=",oidx," index=",index, " steps=",steps, " new_start=",start, " e.len=",execs.length);
            return start;
            //return index;
        }

        return null
    }



    // NOTE: take out (event) IF not calling directly from onClick()!
    //
    const handleMockEdit = (event) => {
        var edit = (EditMode === true) ? false : true;
        //var edit = INFO.mock_edit_mode;
        INFO.mock_edit_mode = edit;
        setEditMode(edit);
        console.log("mock.1365:     . . . . CHANGE EDIT MODE   edit=", edit);

        //resetMockState("mock_edit.1409");     // need this?
        generateMockExecute("mock_edit.1409");
    }


    // NOTE: take out (event) IF not calling directly from onClick()!
    //
    const handleMockDelete = (event) => {
        if (INFO.mock_edit_mode === true) {
            var exec = INFO.mock_execute[INFO.mock_target_idx];
            var detect = INFO.mock_detects[INFO.mock_type][exec.back_idx];
            deleteTargetDetect(INFO.mock_type, detect);       // remove from db
            console.log("mock.1752:     . . . . REMOVE DATA   edit=",INFO.mock_edit_mode, " type=",INFO.mock_type, " detect=",detect);
        }
    }


    // NOTE: take out (event) IF not calling directly from onClick()!
    //
    const handleMockSave = (event) => {
        console.log("mock.1504:     . . . . SAVE DATA   edit=",INFO.mock_edit_mode, " type=",INFO.mock_type);
        if (INFO.mock_edit_mode === true) {
            createTargetDetect(INFO.mock_type);       // also saves to db
        }
    }


    // call from UI control
    //     - step through types
    //
    //const MOCK_TYPES = ["comment", "target", "passing", "position"]
    const handleMockModeToggle =  (event) => {
        var idx = null;
        for(var i =0; i < CONSTS.MOCK_TYPES.length; i++) {
            if (INFO.mock_type.toLowerCase() === CONSTS.MOCK_TYPES[i]) {
                idx = i;
            }
        }

        var index = (idx === (CONSTS.MOCK_TYPES.length - 1)) ? 0 : idx + 1;
        INFO.mock_type  = CONSTS.MOCK_TYPES[index];
        processMockModeChange(INFO.mock_type);

        console.log("mock.1189:  SWITCH MOCK TYPE: ", INFO.mock_type, " edit=",INFO.mock_edit_mode);
    }


    const processMockModeChange =  (type) => {

        INFO.mock_type = type;
        switch(type) {
            case "target":
                if (INFO.mock_edit_mode === false) {
                    resetMockState("mock_mode_toggle.1405");
                    generateMockExecute("mock_mode_toggle.1405");
                    startDetectRun();
                }
                console.log("mock.1301:  . . . . SWITCHED TO target RUN  exec=",INFO.mock_execute, " detects=",INFO.mock_detects);
                break;
        }
        console.log("mock.1331:       ==== SWITCH MODE TO  ", type, "  edit=",INFO.mock_edit_mode);
    }



    //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    //   VIDEO PLAYER HANDLER ROUTINES  (check VideoPlayer.js)
    //
    const handlePlayerPlay = async (event) => {
        var player = INFO.mock_player;
        //var paused = await player.getPaused();
        var paused = player.paused;  // do we really need this?  takes awhile
        if (paused == true) {
            //console.log("mock.515:          KEY START VIDEO  ");    //player=",player);
            player.start();
        } else {
            //console.log("mock.518:          KEY PUASE VIDEO  ");    //player=",player);
            player.pause();
        }
    }


    // control video steps
    //    - if in running mode, step by detect
    const handlePlayerStep = (steps) => (event) => {
        var player = INFO.mock_player;

        if (Math.abs(steps) > 30) {
            processPlayerSkip(steps);       // may skip to next detect based on mode
        } else {
            console.log("mock.1611:       HANDLE SINGLE STEP   steps=",steps);
            player.singleStep(steps);
        }
    }


    // NOTE: take out (event) IF not calling directly from onClick()!
    //
    const handlePlayerSpeed = (speed) => {
        console.log("mock.1074:     . . . . CHANGE SPEED TO ", (speed*100));
        var player = INFO.mock_player;
        INFO.mock_playing_speed = speed;
        player.setSpeed(INFO.mock_playing_speed); 
    }


    // if alt key then skip to end or begining of the detect sequence
    //
    const processPlayerSkip = async (steps, ctrl, alt) => {
        var player = INFO.mock_player;
        var detects = INFO.mock_detects[INFO.mock_type];

        if ((Math.abs(steps) > 30) && ((detects) && (detects.length > 0))) {

            var start = await findNextDetect(steps, ctrl, alt);
            if (start !== null) {      // NOTE: Can not use "">= 0"?!?
                INFO.mock_debug && console.log("mock.1896:       SKIP  steps=",steps, " start=",start, " alt=",alt);
                player.setTime(start - (CONSTS.MOCK_DISPLAY_PREVIEW/1000));
                return;
            }
            console.log("mock.1715:       FAILED SKIP  steps=",steps, " start=",start, " detects=",detects);
        }

        //console.log("mock.1717:       SINGLE STEP  steps=",steps, " detects=",detects);
        player.singleStep(steps);
        //checkDetectBoundary(steps);
    }




    //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    //   KEYBOARD HANDLER ROUTINES
    //

    // examine if current video frame is outside of detect module
    //     - Traverse INFO.mock_execute & TIMES.mock_reacted
    //
    const checkDetectBoundary = async (steps) => {
        var idx = INFO.mock_target_idx;
        var active = INFO.mock_execute[idx];

        if ((INFO.mock_type === "comment") || (Math.abs(steps) === 1) || (active === undefined)) {
            return;     //
        }

        var curr = await INFO.mock_player.getTime();  // can not use React var here!
        if (curr < (active.start - CONSTS.MOCK_DISPLAY_BEFORE_SEC)) {
            idx = idx - 1;
            INFO.mock_target_idx = (idx < 0) ? 0 : idx;

        } else if (curr > (active.end + CONSTS.MOCK_DISPLAY_AFTER_SEC)) {
            idx = idx + 1;
            INFO.mock_target_idx = (idx >= (INFO.mock_execute.length - 1)) ? (INFO.mock_execute.length - 1) : idx;
        } else {
            return;
        }
        //console.log("mock.991:     . . . . DETECT idx=",idx, " curr=",curr, " a.start=",active.start, " a.end=",active.end);

        var player = INFO.mock_player;
        if ((INFO.mock_edit_mode === false) && (player !== null)) {
            idx = INFO.mock_target_idx;
            var detect = INFO.mock_execute[idx];
            var mode = findMockRunMode(INFO.mock_type);
            var clean = player.paused || INFO.mock_edit_mode;
            var [start, end, leader] = calcDetectEndpoints(active.start, active.end, mode, clean);
            console.log("mock.1000:     +++++++ DETECT SKIP TO  idx=",idx, " edit=",INFO.mock_edit_mode," steps=",steps," start=",start," detect=",detect);  //player=", player);
            player.setTime(start);
            //player.setTime(detect.start - (CONSTS.MOCK_DISPLAY_PREVIEW/1000));
        }
    }


    // remove detect object from array
    //
    function deleteTargetDetect(type, detect) {
        var active = {};
        //var targets = TIMES.mock_reacted;
        //var detects = INFO.mock_detects[type];
        //var valid = false;
        //active.points = [];

// TODO: REMOVE ENTRY FROM DB ARRAY


        var body = {"field": INFO.mock_type, "data": detect};
        RemoveTargetDetect(INFO.mock_video_id, body);


    }



    // EDIT: create target run object and write to db
    //    - store current target detector in db (read-merge-write), then start a new one
    //    - comment:  store <origin>, <target>....<target>
    //    - target:  store <origin>, <target0>, <target1>
    //    - passing:  store <origin>, <target0>, <target1>, <target2>
    //    - path:  store <origin>, <target0>
    //
    function createTargetDetect(type) {
        var active = {};
        var targets = TIMES.mock_reacted;       // clicks
        var detects = INFO.mock_detects[type];
        var valid = false;
        active.points = [];

        if (detects === undefined) {
            INFO.mock_detects[type] = [];
            detects = INFO.mock_detects[type];
            console.log("mock.1634:          NO INFO.mock_detects[type]=", INFO.mock_detects);
        }

        if(targets[0] === undefined) {
            console.log("mock.1646:         !!!!!!!!! TIMES.mock_reacted EMPTY!!!");
            return;
        }

        active.type = type;
        active.start = targets[0].video_time;
        active.author = INFO.user_id;
        switch (type) {
            case "comment":
            case "passing":
                // multi-targets
                //
                if(targets.length > 1) {
                    active.points[0] = {node: "origin", time: targets[0].video_time, x: targets[0].x, y: targets[0].y};
                    for (var i = 1; i < targets.length; i++) {
                        var target = targets[i];
                        active.points[i] = {};
                        var point = active.points[i];
                        active.end = target.video_time;
                        point.node = "mark";
                        point.time = target.video_time;
                        point.x = target.x;
                        point.y = target.y;
                    }
                    valid = true;
                }
                console.log("mock.1663:          MOCK comment Write INFO.mock_detects  type=",type, " active=",active);
                break;

            case "path":
            case "position":
                // single target
                //
                if(targets.length === 2) {
                    active.end = targets[1].video_time;
                    active.points = [{node: "origin", time: targets[0].video_time, x: targets[0].x, y: targets[0].y},
                                    {node: "mark1", time: targets[1].video_time, x: targets[1].x, y: targets[1].y}]
                    valid = true;
                }
                break;

            case "target":
                // two targets
                //
                if(targets.length === 3) {
                    active.end = targets[2].video_time;
                    active.points = [{node: "origin", time: targets[0].video_time, x: targets[0].x, y: targets[0].y},
                                    {node: "mark0", time: targets[1].video_time, x: targets[1].x, y: targets[1].y},
                                    {node: "mark1", time: targets[2].video_time, x: targets[2].x, y: targets[2].y}]
                    valid = true;
                }
                break;
        }


        // merge back to db
        //    - /detects/read/<video_id>
        //    - check if this is a dupe
        //    - /detects/update/<video_id>
        if (valid === true) {
            detects.push(active);
            TIMES.mock_reacted = [];     // reset
            INFO.mock_start_time = 0;
            console.log("mock.833:          END OF TARGET DETECT UNIT  video_hash=",INFO.mock_video_hash, " reacted=", TIMES.mock_reacted, " active=",detects);     // player=",player);

            var body = {"field": INFO.mock_type, "data": active};
            InsertTargetDetect(INFO.mock_video_hash, body);
        }

    }


    // hot keys
    //    - <space>:  stop and start video
    //    - t:  target of this pass (start, target)
    //    - p:  all available passing targets (start, target1, target2, ...)
    //    - m:  comment reaction time  (start, a-time, b-time, ....)
    //    - c:  clear current entry
    //    - s:  save current entry to db
    //    - a:  audio on/off
    // 
    const handleKeyDown = async (event) => {
        var player = INFO.mock_player;
        var keycode = event.code;
        var shift = event.shiftKey;
        var ctrl = event.ctrlKey;
        var alt = event.altKey;
        event.preventDefault();     // block new ones to prevent overflow

        //console.log("mock.488:          KEY DOWN:  ", keycode, " shift=",event.shiftKey, " ctrl=",event.ctrlKey, " player=",player.type);
        //console.log("mock.1341:          active=", INFO.mock_execute[INFO.mock_target_idx]);
        if (player === null) {
            return;
        }

        switch(keycode) {
            case "Space":
                handlePlayerPlay();
                break;

            case "ArrowLeft":
                var steps = findSkipSteps(shift, ctrl, alt);
                processPlayerSkip(-steps, ctrl, alt);
                break;
            case "ArrowRight":
                var steps = findSkipSteps(shift, ctrl, alt);
                processPlayerSkip(steps, ctrl, alt);
                break;

            case "KeyM":
                processMockModeChange("comment")
                break;
            case "KeyT":
                processMockModeChange("target")
                break;
            case "KeyR":
                processMockModeChange("passing")
                break;
            case "KeyP":
                processMockModeChange("position")
                break;
            case "KeyC":
                handleMockClear();
                break;

            case "KeyE":
                handleMockEdit();
                break;

            case "KeyQ":
                if (INFO.mock_edit_mode === true) {
                    createTargetDetect(INFO.mock_type);       // also saves to db
                } else {
                    console.log("mock.1745:      !!!!!!!! UNABLE TO SAVE, NOT IN EDIT MODE!");
                }
                break;

            case "KeyA":
                //console.log("mock.512:          FORWARD STEP VIDEO  ");     // player=",player);
                player.mute();
                break;
            case "Digit0":
                //console.log("mock.512:          FORWARD STEP VIDEO  ");     // player=",player);
                player.setSpeed(0.5);
                break;
            case "Digit1":
                //console.log("mock.512:          FORWARD STEP VIDEO  ");     // player=",player);
                player.setSpeed(1);
                break;
            case "Digit2":
                //console.log("mock.512:          FORWARD STEP VIDEO  ");     // player=",player);
                player.setSpeed(2);
                break;
        }
    }

    // dynamic in-game debug toggle
    //
    const handleMockDebug = () => {
        //var canvas1 = document.querySelector('#mock_buffer1');

        console.log("mock.1616:      MOCK DEBUG MODE DETECED  mock_execute=", INFO.mock_execute, " edit=",INFO.mock_edit_mode);
        if (INFO.mock_debug === true) {
            INFO.mock_debug = false;
            //canvas1.style.display = "none";
        } else {
            INFO.mock_debug = true;
            //canvas1.style.display = "block";
        }
    }

    const handleFootage = (timeline) => {

        var footages = INFO.mock_tot_footages;
        var detects = INFO.mock_tot_detects;
        var footage = footages.filter(foot => { return foot.timeline == timeline });
        var all_detects = detects.filter(detect => { return detect.video_hash == footage[0].hash });
        installFootage(footage[0], "handle_footage.2851");
        console.log("mock.2554:      HANDLE NEW FOOTAGE:  footage=", footage[0], " all_detects=",all_detects, " detects=",detects);
        installDetects(footage[0], all_detects[0]);
        resetMockState("hand_footage.2687");
        generateMockExecute("hand_footage.2687");
    }



    const renderRedirect = () => {
        if (TargetRedirect !== "") {
            GATag("menu", Target, "jump");  // (cat, act, lab, val)
            console.log("mock.503:      ###########  menu.renderRedirect:   Showing ", Target);
            return <Redirect to={Target} />
        }
        return ""
    }

                                /*
                                //Display={ShowPreFlight}  /> 
                                    Width={props.SelectedItem.width} 
                                    Height={props.SelectedItem.height} 
                                    Width={VideoWidth} 
                                    Height={VideoHeight} 
                                    VimeoType={VimeoType}

                            <FaEdit style={{position: "absolute", top: '6px',
                                    right: ((16 * INFO.mock_scale_x) - 20) + "px",
                                    fontSize: (0.35 * INFO.mock_scale_x) +"rem",
                                    color: "#ffffff40", zIndex: "300" }} 
                                    className={classes.edit_icon} />
                        }
                                    */

    return (
        <React.Fragment>

            { ShowTutorial && <Tutorial  Show={Show} Dismiss={handleDismissTutorial}/> }
            <Fade in={State.Authed} timeout={{enter: 2000, exit: 2000}}>
                <React.Fragment>
                    {false && ShowSteps && <Notice Instrns={Instrns} BarColor={"yellow"} FontColor={"red"} Display={ShowSteps} />}
                    {ShowPreFlight && 
                        <Notice Instrns={WarningText} 
                                BarColor={"#c3ab19"} 
                                FontColor={"white"} 
                                Style={{position: "absolute", top: "0px", left: "0px"}} 
                                Display={ShowPreFlight} /> }

                    {ShowWarning && 
                        <Notice Instrns={WarningText} 
                                BarColor={"red"} 
                                FontColor={"white"} 
                                Style={{position: "absolute", top: "0px", left: "0px"}}
                                Display={ShowWarning}  /> }

                    <Container id="drill_video_container" className={classes.mock_root}>
                        {ShowDirection && <Direction Style={{top: '0px'}} Directions={props.UseDirections} />}

                        {(EditMode === true) && 
                            <FaEdit id="edit_icon" style={{position: "absolute", top: '6px',
                                right: ((16 * INFO.mock_scale_x) - 30) + "px",
                                fontSize: (0.35 * INFO.mock_scale_x) +"rem",
                                color: "#00ff00de", zIndex: "300" }} 
                                className={classes.edit_icon} />
                        }


                        {(ShowEdit) &&
                            <VideoControl Play={handlePlayerPlay} 
                                Step={handlePlayerStep} 
                                Mode={handleMockModeToggle} 
                                Clear={handleMockClear} 
                                Edit={handleMockEdit} 
                                Save={handleMockSave} 
                                Delete={handleMockDelete} 
                                Footages={Footages}
                                HandleFootage={handleFootage}
                                Speed={handlePlayerSpeed} />
                        } 


                        {(true || ShowVideo) && 
                        <React.Fragment>
                            <canvas id="mock_input" 
                                onKeyDown={handleKeyDown}
                                className={classes.mock_input_layer} />

                            <canvas id="mock_buffer0" 
                                className={classes.mock_buffer_layer} />

                            <canvas id="mock_buffer1" 
                                className={classes.mock_buffer_layer} />
                        </React.Fragment>}


                        <Container className={classes.stars_container}>
                            <Stars StarCnt={StarCnt}/>
                        </Container>

                        {/* BAD: <Container id="drill_output0" className={classes.mock_canvas}>*/}
                        <Container id="drill_output0" className={classes.mock_canvas}>
                            <VideoFrame Source={INFO.video_url} 
                                    SelectedItem={props.SelectedItem}
                                    Loop={false} 
                                    Width={VideoWidth} 
                                    Height={VideoHeight} 
                                    PlayerType={PlayerType}
                                    Style={classes.drill_iframe} 
                                    onReady={handleVideoPlayerReady}
                                    onStateChange={handleVideoStateChange}

                                    Player={VideoPlayer}
                                    Footage={Footage} 
                                    onSetup={handleMockMetadataReady}
                                    />
                        </Container>


                        {false && <canvas id="drill_output" className={classes.mock_canvas} />}
                        <div key="easter3" id="mock_easter_right" className={classes.easter_container}  style={{right: '0px' }} onClick={handleMockDebug}/>
                    </Container>


                </React.Fragment>
            </Fade>

            {renderRedirect()}
        </React.Fragment>
    )
}

export default withRouter(Mock)